
import React, { useEffect, useState, useRef } from "react";
import { usePaymentDropdowns } from "../../hooks/usePaymentDropdowns";
import { Tag, Row, Col, Card, Button, Divider, Spin, Typography, notification, Avatar, Drawer, Space, Form, Input, InputNumber, Select, Checkbox, DatePicker, Modal, message, Table, AutoComplete, Switch } from "antd";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { baseUrl } from "../../config";
import { UserOutlined, PhoneOutlined, CalendarOutlined, CheckCircleOutlined, TeamOutlined, SaveOutlined, EditOutlined, PlusOutlined, CameraOutlined, ScanOutlined, CheckOutlined, ReloadOutlined, ClearOutlined, ArrowRightOutlined } from '@ant-design/icons';
import '../../assets/styles/custom_style.css';
import UserModalContent from './UserModalContent';
import UserPaymentModalHistory from './UserPaymentModalHistory';
import AddUserDetailsModel from './AddUserDetailsModel';
import moment from 'moment';
import _ from 'lodash';
import userDummy from "../../assets/images/dummy-user.png";
import { SearchOutlined, UserAddOutlined } from '@ant-design/icons';
import { CloseOutlined, StarFilled, TrophyFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';

const getLoyaltyBadge = (years) => {
  if (!years || years < 1) return null;
  if (years >= 10) return { label: `${years}yr`, color: '#722ed1', bg: '#f9f0ff', title: `💎 Lifetime Member — ${years} years` };
  if (years >= 5)  return { label: `${years}yr`, color: '#d4a017', bg: '#fffbe6', title: `🥇 Veteran Member — ${years} years` };
  if (years >= 3)  return { label: `${years}yr`, color: '#8c8c8c', bg: '#f5f5f5', title: `🥈 Senior Member — ${years} years` };
  return            { label: `${years}yr`, color: '#8B4513', bg: '#fdf6ec', title: `🥉 Member — ${years} years` };
};

// const { Title } = Typography;
const { Text, Title } = Typography;

const reverseRelationMapping = {
    "सुपुत्र श्री":    "Son of Mr.",
    "सुपुत्री श्री":   "Daughter of Mr.",
    "पत्नी श्री":      "Wife of Mr.",
    "पत्‍नी श्री":     "Wife of Mr.",
    "गोद पुत्र श्री":  "Adopted Son of Mr.",
    "शिष्य श्री":      "Disciple of Mr.",
    "व्यवसाय/अन्य":    "Business/Other",
};
const { Item } = Form;
const { Option } = Select;
const { RangePicker } = DatePicker;

function PaymentsForm() {
    const { id } = useParams();
    const history = useHistory();
    const [form] = Form.useForm();
    const [isUpdateMode, setIsUpdateMode] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [file, setFile] = useState(null);
    const [userBasicDetail, setuserBasicDetail] = useState({});
    const [userBadges, setUserBadges] = useState({ account_count: 0, years_active: 0 });
    const [userId, setUserId] = useState(null);
    const [profileImg, setProfileImg] = useState(null);
    const [isModalForConfirmation, setIsModalForConfirmation] = useState(false);
    const [checkedOption, setCheckedOption] = useState('');
    const [alternativeNumber1, setAlternativeNumber1] = useState(null);
    const [alternativeNumber2, setAlternativeNumber2] = useState(null);
    const [phoneNumberUse, setPhoneNumberUse] = useState(null);
    const [primaryId, setPrimaryId] = useState('');
    const [childrenId, setChildrenId] = useState(null);
    const [isModalAddMember, setIsModalAddMember] = useState(false);
    const [childrenList, setChildrenList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleImg, setIsModalVisibleImg] = useState(false);
    const [addedUserData, setAddedUserData] = useState(null);
    const [paymentUserData, setpaymentUserData] = useState(null);
    const [paidMonths, setPaidMonths] = useState([]);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [showMonthCoverd, setshowMonthCoverd] = useState(true);
    const [lastPayment, setLastPayment] = useState('');
    const [loading, setLoading] = useState(false);

    const [showSpecialOccassionCategory, setSpecialOccassionCategory] = useState(false);
    const [showCategoryPay, setCategoryPay] = useState(true);
    const [isCustomOccasion, setIsCustomOccasion] = useState(false);
    const [countryCode, setCountryCode] = useState('91');
    const [UserPaymentHistory, setUserPaymentHistory] = useState(false);
    const [AddUserDetailsFormModel, setAddUserDetailsModel] = useState(false);
    const [AddEditUserDetailsForm, setAddEditUserDetailsForm] = useState(null);
    const [paymentStatus, setPaymentStatus] = useState('pending');
    const [optionSuggestion, setOptionSuggestion] = useState([]);
    const [transactionDate, setTransactionDate] = useState(moment().format('YYYY-MM-DD'));
    const [switchChecked, setSwitchChecked] = useState(false);
    const [showEReceiptFields, setShowEReceiptFields] = useState(false);
    const [showGatewayFields, setShowGatewayFields] = useState(false);
    const [erecipt_date, setErecipt_date] = useState();
    const actionRef = useRef('save');
    const [action, setAction] = useState('save');
    const [userComment, setUserComment] = useState('');
    const [isVisheshSahyogi, setIsVisheshSahyogi] = useState(false);
    const [visheshSahyogiData, setVisheshSahyogiData] = useState(null);
    const [isInactiveWarningVisible, setIsInactiveWarningVisible] = useState(false);
    const [isShopDonation, setIsShopDonation] = useState(false);

    // Village master autocomplete
    const [villageOptions, setVillageOptions] = useState([]);
    const [villageSearching, setVillageSearching] = useState(false);
    const villageTimerRef = useRef(null);

    const searchVillage = (q) => {
        clearTimeout(villageTimerRef.current);
        if (!q || q.length < 1) { setVillageOptions([]); setVillageSearching(false); return; }
        setVillageSearching(true);
        villageTimerRef.current = setTimeout(async () => {
            try {
                const res = await axios.get(`${baseUrl}/village/search`, {
                    params: { q },
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });
                setVillageOptions((res.data.result || []).map(v => {
                    const parts = [v.name_en];
                    if (v.name_hn) parts.push(v.name_hn);
                    const loc = [v.tehsil_en, v.district_en].filter(Boolean).join(', ');
                    return { value: v.name_en, label: loc ? `${parts.join(' / ')} — ${loc}` : parts.join(' / '), data: v };
                }));
            } catch { setVillageOptions([]); }
            finally { setVillageSearching(false); }
        }, 300);
    };

    const handleVillageSelect = (_, option) => {
        const v = option.data;
        form.setFieldsValue({
            per_village_en:  v.name_en    || '',
            per_village_hn:  v.name_hn    || '',
            per_tahsil_en:   v.tehsil_en  || '',
            per_tahsil_hn:   v.tehsil_hn  || '',
            per_district_en: v.district_en || '',
            per_district_hn: v.district_hn || '',
            per_village_id:  v.id,
        });
    };

    // Referral state (only for new members)
    const [refSource, setRefSource] = useState(null);
    const [refMemberOptions, setRefMemberOptions] = useState([]);
    const [refMemberSearching, setRefMemberSearching] = useState(false);
    const [refDialogOpen, setRefDialogOpen] = useState(false);
    const [refDialogLoading, setRefDialogLoading] = useState(false);
    const [refDialogSource, setRefDialogSource] = useState(null);
    const [refDialogMemberOptions, setRefDialogMemberOptions] = useState([]);
    const [refDialogMemberSearching, setRefDialogMemberSearching] = useState(false);
    const [refDialogForm] = Form.useForm();

    const [isCalendar, setIsCalendar] = useState('');
    const [noCalendar, setNoCalendar] = useState('');
    const [calendarPerName, setCalendarPerName] = useState('');
    const [isHonored, setIsHonored] = useState('');
    const [isBankAccountDisabled, setIsBankAccountDisabled] = useState(false);
    const { bankAccounts: bankAccountOptions, specialOccasions: specialOccasionOptions } = usePaymentDropdowns();
    const [isHovered, setIsHovered] = useState(false);
    const [currentImage, setCurrentImage] = useState("");

    // Add ref to track if last payment API has been called for current user
    const lastPaymentFetched = useRef(new Set());

    // Enhanced state management for member details
    const [memberDetailsMode, setMemberDetailsMode] = useState('view'); // 'view', 'edit', 'create'
    const [isNewMember, setIsNewMember] = useState(false);

    // ── Screenshot extraction ──────────────────────────────────────────────────
    const [screenshotImg, setScreenshotImg]       = useState(null);  // preview data-url
    const [extractLoading, setExtractLoading]     = useState(false);
    const [extractResult, setExtractResult]       = useState(null);  // { amount, utr_number, transaction_date }
    const screenshotInputRef = useRef(null);

    const handleScreenshotFile = (file) => {
        if (!file || !file.type.startsWith('image/')) return;
        const reader = new FileReader();
        reader.onload = (e) => setScreenshotImg(e.target.result);
        reader.readAsDataURL(file);
    };

    const handleScreenshotPaste = (e) => {
        const items = e.clipboardData?.items;
        if (!items) return;
        for (const item of items) {
            if (item.type.startsWith('image/')) {
                handleScreenshotFile(item.getAsFile());
                break;
            }
        }
    };

    const extractFromScreenshot = async () => {
        if (!screenshotImg) return;
        setExtractLoading(true);
        try {
            const base64 = screenshotImg.split(',')[1];
            const res = await axios.post(`${baseUrl}/payments/extract-screenshot`,
                { image: base64 },
                { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
            );
            if (res.data.success) {
                const { amount, utr_number, transaction_date } = res.data.data;
                const fields = {};
                if (amount)          fields.amount     = amount;
                if (utr_number)      fields.utr_number = utr_number;
                form.setFieldsValue(fields);
                if (transaction_date) setTransactionDate(transaction_date);
                setExtractResult(res.data.data);
                message.success('Payment details extracted successfully!');
                if (utr_number) {
                    getPanelValue(utr_number, 'utr_number', 'sn_payments');
                }
            } else {
                message.error(res.data.message || 'Could not extract details');
            }
        } catch (err) {
            message.error(err.response?.data?.message || 'Extraction failed');
        } finally {
            setExtractLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            setIsUpdateMode(true);
            fetchUserDetails();
        }
    }, [id]);


    useEffect(() => {
        const fetchPaidMonths = async () => {
            try {
                setPaidMonths([])
                const months = await getPaidMonths(userId);
            } catch (error) {
                message.error('Failed to fetch paid months');
            }
        };

        if (userId) {
            fetchPaidMonths();
        }
    }, [userId]);

    // Fix the duplicate API call issue for last payment
    useEffect(() => {
        const getLastPayment = async () => {
            try {
                // Check if we already fetched for this user
                if (userId && !lastPaymentFetched.current.has(userId)) {
                    lastPaymentFetched.current.add(userId);
                    await getLastPaymentDetail(userId);
                }
            } catch (error) {
                message.error('Failed to fetch last payment details');
            }
        };

        if (userId) {
            getLastPayment();
        }
    }, [userId]);

    useEffect(() => {
        const userId = localStorage.getItem('userId');
        if (userId === '71') {
            form.setFieldsValue({
                bank_account: '2',
            });
            handlePaymentTypeChange(2);
            setIsBankAccountDisabled(true);
        } else {
            form.setFieldsValue({
                bank_account: '1',
            });
            setIsBankAccountDisabled(false);
        }
    }, [form]);




    const getLastPaymentDetail = async (userId) => {
        if (userId) {
            try {
                const response = await axios.get(
                    `${baseUrl}/payments/get-last-payment?userId=${userId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                        },
                    }
                );
                if (response.status === 200) {
                    // Fix: Access the nested data structure properly
                    const paymentData = response.data.result?.[0]?.[0];
                    if (paymentData) {
                        setLastPayment([paymentData]); // Wrap in array for consistency
                    } else {
                        setLastPayment(null);
                    }
                } else {
                    setLastPayment(null);
                }
            } catch (error) {
                console.error('Error fetching last payment:', error);
                setLastPayment(null);
            }
        }
    };

    const fetchUserDetails = async () => {
        try {
            const response = await axios.get(`${baseUrl}/payments/read/${id}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            });
            if (response.status === 200) {
                const userData = response.data.result;
                setTransactionDate(userData.transaction_date ? moment(userData.transaction_date) : null);
                userData.payment_entry_date = userData.payment_entry_date ? moment(userData.payment_entry_date) : null;
                form.setFieldsValue(userData);

                if (userData.profile_img) {
                    setImageUrl(userData.profile_img);
                }
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };

    const onFinish = async (values) => {
        setLoading(true);
        try {
            // Validate that user is selected
            // if (!userId) {
            // if (!userId && !isNewMember) {
            //     notification.error({
            //         message: 'Error',
            //         description: 'Please search and select a member before adding payment.',
            //         placement: 'topRight'
            //     });
            //     setLoading(false);
            //     return;
            // }

            values.is_special_occassion = values.is_special_occasion ? 1 : 0;

            const formData = new FormData();

            Object.keys(values).forEach(key => {
                const val = key === 'ref_member_id' && values[key]?.value !== undefined
                    ? values[key].value
                    : values[key];
                formData.append(key, val !== undefined ? val : '');
            });
            
            if (file) {
                formData.append("file", file);
            }
            if (userId) {
                formData.append("userId", userId);
            }
            if (transactionDate) {
                formData.append("transaction_date", transactionDate);
            }
            if (countryCode) {
                formData.append("country_code", countryCode);
            }
            if (actionRef.current) {
                formData.append("action", actionRef.current);
            }
            if (erecipt_date) {
                const formattedDate = moment(erecipt_date).format('YYYY-MM-DD');
                formData.append("e_reciept_date", formattedDate);
            }

            const response = await axios.post(`${baseUrl}/payments/create`, formData, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            });

            if (response.status === 200) {
                setLoading(false);
                localStorage.setItem('payment_added', 'true');

                let successMessage = 'Payment added successfully!';
                if (actionRef.current === 'not_send') {
                    successMessage = 'Payment added successfully! (No poster/message sent)';
                } else {
                    successMessage = 'Payment added successfully! Poster generated and WhatsApp message sent.';
                }

                notification.success({
                    message: 'Success',
                    description: successMessage,
                    placement: 'topRight',
                    duration: 4.5,
                });

                // Reset form but keep user data
                const userFields = ['user_id', 'name_eng', 'father_name_en', 'relation_en', 'name_hn', 'father_name_hn', 'relation_hn', 'per_village_en', 'per_tahsil_en', 'per_district_en', 'per_village_hn', 'per_tahsil_hn', 'per_district_hn', 'per_address_en', 'per_address_hn'];
                const userFieldValues = {};
                userFields.forEach(field => {
                    userFieldValues[field] = form.getFieldValue(field);
                });

                form.resetFields();
                form.setFieldsValue(userFieldValues);
                
                setTimeout(() => {
                    if (actionRef.current === 'save') {
                        history.push(`/payments/view/${response.data.data.user.id}`);
                    } else if (actionRef.current === 'next' || actionRef.current === 'not_send') {
                        window.location.reload();
                    }
                }, 1000);

            } else {
                setLoading(false);
                notification.error({
                    message: 'Error',
                    description: response.data.message || 'Failed to add payment',
                    placement: 'topRight'
                });
            }
        } catch (error) {
            setLoading(false);
            console.error("API error:", error);
            
            const errorMessage = error.response?.data?.message || 'An error occurred while adding payment';
            
            notification.error({
                message: 'Error',
                description: errorMessage,
                placement: 'topRight'
            });
        }
    };

    // Enhanced handleIdChange function to properly handle new member creation
    const handleIdChange = (id, newUserData = null) => {
        setPrimaryId(null);
        setUserId(id);
        setChildrenId(id);
        setIsNewMember(false);
        
        // Clear the fetched cache when user changes
        lastPaymentFetched.current.clear();

        // If new user data is provided, update the form
        if (newUserData) {
            const { name_eng, father_name_en, relation_en, name_hn, father_name_hn, relation_hn, phone_no, profile_img, per_village_en, per_tahsil_en, per_district_en, per_village_hn, per_tahsil_hn, per_district_hn, per_address_en, per_address_hn } = newUserData;

            setProfileImg(profile_img);
            setPhoneNumber(phone_no);
            setPhoneNumberUse(phone_no);

            form.setFieldsValue({
                phone_no: phone_no,
                user_id: id,
                name_eng: name_eng,
                father_name_en: father_name_en,
                relation_en: relation_en,
                name_hn: name_hn,
                father_name_hn: father_name_hn,
                relation_hn: relation_hn,
                per_village_en: per_village_en,
                per_tahsil_en: per_tahsil_en,
                per_district_en: per_district_en,
                per_village_hn: per_village_hn,
                per_tahsil_hn: per_tahsil_hn,
                per_district_hn: per_district_hn,
                per_address_en: per_address_en || '',
                per_address_hn: per_address_hn || '',
            });

            notification.success({
                message: 'Success',
                description: 'New member created successfully! You can now add their payment details.',
                placement: 'topRight'
            });
        }
    };

    const getPaidMonths = async (userId) => { 
        if (userId) {
            const response = await axios.get(
                `${baseUrl}/payments/overlap-check?userId=${userId}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );
            if (response.status === 200) {
                const paidMonths = response.data.result.map(date => moment(date, 'YYYY-MM-DD').add(15, 'days'));
                setPaidMonths(paidMonths);

                if (response.data?.today?.length > 0) {
                    message.error("Payment for today has already been recorded for this member.");
                }
            }
        }
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setAddedUserData(null);
        history.push('/payments');
    };

    const handleModalForConfirmationClose = () => {
        setIsModalForConfirmation(false);
    };

    const handleModalNewMemberClose = () => {
        setIsModalAddMember(false);
    };


     const checkVisheshSahyogiStatus = async (phoneNumber) => {
  try {
    const response = await axios.get(
      `${baseUrl}/vishesh_sahyogi/check-by-phone?phone=${phoneNumber}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    );
    
    if (response.data.exists) {
      setIsVisheshSahyogi(true);
      setVisheshSahyogiData(response.data.details);
      return true;
    } else {
      setIsVisheshSahyogi(false);
      setVisheshSahyogiData(null);
      return false;
    }
  } catch (error) {
    console.error('Error checking Vishesh Sahyogi status:', error);
    setIsVisheshSahyogi(false);
    setVisheshSahyogiData(null);
    return false;
  }
};


    const handlePhoneNumberChange = async (e) => {
        // Strip everything except digits
        const value = e.target.value.replace(/[^\d]/g, '').slice(0, 12);
        setPhoneNumber(value);
        form.setFieldsValue({ phone_no: value });
        const minLength = countryCode === '91' ? 10 : 5;
        if (value.length >= minLength) {
            setPhoneNumberUse(value);
            await checkPhoneNumber(value);
            await checkVisheshSahyogiStatus(value);
        } else {
            clearUserData();
        }
    }

    // const clearUserData = () => {
    //     setLastPayment(null);
    //     setUserId(null);
    //     setProfileImg(null);
    //     setChildrenId(null);
    //     setChildrenList([]);
    //     setPrimaryId(null);
    //     setIsNewMember(false);

    //     form.setFieldsValue({
    //         user_id: '',
    //         name_eng: '',
    //         father_name_en: '',
    //         profile_img: '',
    //         relation_en: '',
    //         father_name_hn: '',
    //         name_hn: '',
    //         relation_hn: '',
    //         amount_announce: '',
    //         duration_type: '',
    //         per_village_en: '',
    //         per_tahsil_en: '',
    //         per_district_en: '',
    //         per_village_hn: '',
    //         per_tahsil_hn: '',
    //         per_district_hn: '',
    //         is_calendar: '',
    //         no_calendar: '',
    //         calendar_per_name: '',
    //         is_honored: ''
    //     });
    // };

        const searchRefMember = async (q) => {
        if (!q || q.length < 2) { setRefMemberOptions([]); return; }
        setRefMemberSearching(true);
        try {
            const res = await axios.get(`${baseUrl}/users/search-member`, {
                params: { q },
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
            });
            setRefMemberOptions((res.data.result || []).map(m => ({
                value: String(m.id),
                label: `${m.name} (${m.phone_no})`
            })));
        } catch { setRefMemberOptions([]); }
        finally { setRefMemberSearching(false); }
    };

    const openRefDialog = async () => {
        refDialogForm.resetFields();
        setRefDialogSource(null);
        setRefDialogMemberOptions([]);
        setRefDialogOpen(true);
        if (userId) {
            try {
                const res = await axios.get(`${baseUrl}/users/referral-info/${userId}`, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });
                if (res.data?.status && res.data.result) {
                    const { ref_source, ref_member_id, ref_member_name, ref_member_phone, ref_note } = res.data.result;
                    setRefDialogSource(ref_source || null);
                    if (ref_member_id && ref_member_name) {
                        setRefDialogMemberOptions([{
                            value: String(ref_member_id),
                            label: `${ref_member_name} (${ref_member_phone || ''})`
                        }]);
                    }
                    refDialogForm.setFieldsValue({
                        ref_source: ref_source || undefined,
                        ref_member_id: ref_member_id ? { value: String(ref_member_id), label: `${ref_member_name} (${ref_member_phone || ''})` } : undefined,
                        ref_note: ref_note || '',
                    });
                }
            } catch (_) {}
        }
    };

    const searchRefDialogMember = async (q) => {
        if (!q || q.length < 2) { setRefDialogMemberOptions([]); return; }
        setRefDialogMemberSearching(true);
        try {
            const res = await axios.get(`${baseUrl}/users/search-member`, {
                params: { q },
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
            });
            setRefDialogMemberOptions((res.data.result || []).map(m => ({
                value: String(m.id),
                label: `${m.name} (${m.phone_no})`
            })));
        } catch { setRefDialogMemberOptions([]); }
        finally { setRefDialogMemberSearching(false); }
    };

    const saveRefDialog = async () => {
        try {
            const vals = await refDialogForm.validateFields();
            const ref_member_id = vals.ref_member_id?.value ?? vals.ref_member_id ?? null;
            setRefDialogLoading(true);
            if (userId) {
                const res = await axios.patch(
                    `${baseUrl}/users/update-referral/${userId}`,
                    { ref_source: vals.ref_source || null, ref_member_id: ref_member_id || null, ref_note: vals.ref_note || null },
                    { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
                );
                if (res.data?.status) {
                    message.success('Referral info saved.');
                    setRefDialogOpen(false);
                } else {
                    message.error(res.data?.message || 'Save failed.');
                }
            } else {
                // New member: push values into main form
                form.setFieldsValue({
                    ref_source: vals.ref_source || undefined,
                    ref_member_id: vals.ref_member_id || undefined,
                    ref_note: vals.ref_note || '',
                });
                setRefSource(vals.ref_source || null);
                message.success('Referral info set.');
                setRefDialogOpen(false);
            }
        } catch (_) {}
        finally { setRefDialogLoading(false); }
    };

    const clearUserData = () => {
        setLastPayment(null);
        setUserId(null);
        setProfileImg(null);
        setChildrenId(null);
        setChildrenList([]);
        setPrimaryId(null);
        setIsNewMember(false);
        setIsVisheshSahyogi(false);
        setVisheshSahyogiData(null);
        setIsShopDonation(false);
        setRefSource(null);
        setRefMemberOptions([]);
        form.setFieldsValue({ ref_source: undefined, ref_member_id: undefined, ref_note: '' });

        form.setFieldsValue({
            user_id: '',
            name_eng: '',
            father_name_en: '',
            profile_img: '',
            relation_en: 'Son of Mr.',
            father_name_hn: '',
            name_hn: '',
            relation_hn: 'सुपुत्र श्री',
            amount_announce: '',
            duration_type: '',
            per_village_en: '',
            per_tahsil_en: '',
            per_district_en: '',
            per_village_hn: '',
            per_tahsil_hn: '',
            per_district_hn: '',
            is_calendar: '',
            no_calendar: '',
            calendar_per_name: '',
            is_honored: ''
        });
    };


    const checkPhoneNumber = async (phone, type = '') => {
        try {
            setIsModalForConfirmation(false);
            setAlternativeNumber2(null);
            setAlternativeNumber1(null);
            // Clear last payment cache when checking new phone
            lastPaymentFetched.current.clear();
            
            const response = await axios.post(
                `${baseUrl}/payments/checkUserPhone`,
                { phone_no: phone },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );
            if (response.status === 200 && response.data.exists) {

                setProfileImg(response.data.exists.profile_img);
                setIsNewMember(false);

                form.setFieldsValue({
                    comment: response.data.details?.payment_comment || '',
                })

                console.log("response.data?.children?.length", response.data?.children?.length);
                if (response.data?.children?.length > 0) {
                    const combinedList = [response.data.details, ...response.data.children];
                    setChildrenList(combinedList);
                }

                setSwitchChecked(response.data.details.status)
                if (phone === response.data.details.alternate_phone_no) {
                    setIsModalForConfirmation(true);
                    setAlternativeNumber1(response.data.details.phone_no);
                } else if (phone === response.data.details.alternate_phone_no2) {
                    setIsModalForConfirmation(true);
                    setAlternativeNumber2(response.data.details.phone_no);
                }

                handleChangeData(response.data.details, false);

                if (type == 'view') {
                    setAddedUserData(response.data.details);
                }

            } else {
                // No user found, prepare for new member creation
                setIsNewMember(true);
                clearUserData();
                
                notification.info({
                    message: 'New Member',
                    description: 'No member found with this phone number. You can create a new member.',
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error('There was an error!', error);
            message.error('Error checking phone number');
        }
    };

    // Enhanced AddUserDetails function
    const AddUserDetails = async () => {
        try {
            setpaymentUserData(null);
            setAddEditUserDetailsForm(null);
            setuserBasicDetail(null);
            
            const values = await form.validateFields(['phone_no']);
            const phoneNumber = values.phone_no;

            if (countryCode === '91' && phoneNumber.length < 10) {
                notification.warning({
                    message: 'Warning',
                    description: 'Please enter a valid phone number first.',
                    placement: 'topRight'
                });
                return;
            }

            // Determine the mode based on whether user exists
            if (userId && !isNewMember) {
                // Existing user - edit mode
                setMemberDetailsMode('edit');
                await checkPhoneNumberView(phoneNumber, 'view');
            } else {
                // New user - create mode
                setMemberDetailsMode('create');
            }

            // Prepare basic user details
            setuserBasicDetail({
                'phone_no': phoneNumber,
                'country_code': countryCode,
                'name_eng': form.getFieldValue('name_eng'),
                'relation_en': form.getFieldValue('relation_en'),
                'father_name_en': form.getFieldValue('father_name_en'), 
                'name_hn': form.getFieldValue('name_hn'),
                'relation_hn': form.getFieldValue('relation_hn'),
                'father_name_hn': form.getFieldValue('father_name_hn'),
                'per_village_en': form.getFieldValue('per_village_en'),
                'per_tahsil_en': form.getFieldValue('per_tahsil_en'),
                'per_district_en': form.getFieldValue('per_district_en'),
                'per_village_hn': form.getFieldValue('per_village_hn'),
                'per_tahsil_hn': form.getFieldValue('per_tahsil_hn'),
                'per_district_hn': form.getFieldValue('per_district_hn'),
                'per_address_en': form.getFieldValue('per_address_en'),
                'per_address_hn': form.getFieldValue('per_address_hn'),
                'is_calendar': form.getFieldValue('is_calendar'),
                'no_calendar': form.getFieldValue('no_calendar'),
                'calendar_per_name': form.getFieldValue('calendar_per_name'),
                'is_honored': form.getFieldValue('is_honored')
            });

            setAddUserDetailsModel(true);
        } catch (error) {
            console.error('Error in AddUserDetails:', error);
            notification.error({
                message: 'Error',
                description: 'Failed to open member details form.',
                placement: 'topRight'
            });
        }
    }

    const AddUserDetailsClose = () => {
        setAddUserDetailsModel(false);
        setMemberDetailsMode('view');
    }

    // Rest of your existing functions remain the same...
    // (I'll include the key ones that need modification)

    const getChildrenById = async (id, type = '') => {
        try {
            const response = await axios.post(
                `${baseUrl}/payments/checkUserById`,
                { id: id },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );
            if (response.status === 200 && response.data.exists) {
                // Fix: Show success notification at topRight
                notification.success({
                    message: 'User Found',
                    description: 'This is an already existing user. Please add their payment details.',
                    placement: 'topRight'
                });

                const { user_id, phone_no, name_eng, father_name_en, relation_en, name_hn, relation_hn, father_name_hn, announced_amount, announced_type, announced_for_year, alternate_phone_no, alternate_phone_no2, profile_img, campaign, mission_monthly_amount } = response.data.details;

                setUserId(user_id);
                setProfileImg(profile_img);
                setuserBasicDetail(response.data.details);
                form.setFieldsValue({
                    user_id: user_id,
                    name_eng: name_eng || '',
                    father_name_en: father_name_en || '',
                    relation_en: (reverseRelationMapping[relation_en] || relation_en) || 'Son of Mr.',
                    father_name_hn: father_name_hn || '',
                    name_hn: name_hn || '',
                    relation_hn: relation_hn || 'सुपुत्र श्री',
                    month_share_amount: announced_amount,
                    frequency_type: announced_type,
                    announced_pay_year: announced_for_year
                });

                if (type == 'view') {
                    setAddedUserData(response.data.details);
                }

            } else {
                setUserId(null);
                setProfileImg(null);
                clearUserData();
            }
        } catch (error) {
            console.error('There was an error!', error);
            message.error('Error checking phone number');
        }
    };

    const checkPhoneNumberView = async (phone, type = '') => {
        try {
            setAddEditUserDetailsForm(null)
            setpaymentUserData(null);

            console.log("childrenId", childrenId);
            const response = await axios.post(
                `${baseUrl}/payments/checkUserByIdView`,
                { id: userId },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    },
                }
            );
            if (response.status === 200 && response.data.exists) {
                if (type == 'view') {
                    const phone_no = form.getFieldValue('phone_no');
                    setAddEditUserDetailsForm(response.data.details, phone_no);
                    console.log("response.data.details.userid", response.data.details.userid)
                    setpaymentUserData(response.data.details.userid, phone_no);
                }
            }
        } catch (error) {
            console.error('There was an error!', error);
            message.error('Error checking phone number');
        }
    };

    const handlePaymentTypeChange = async (value) => {
        if (value === '1') {
            setshowMonthCoverd(true)
        } else {
            setshowMonthCoverd(false)
        }
    }

    const handleSpecialOccassionCategory = (e) => {
        const isChecked = e.target.checked;
        setSpecialOccassionCategory(isChecked);
        setCategoryPay(!isChecked);
        if (!isChecked) {
            setIsCustomOccasion(false);
            form.setFieldsValue({ special_occassion_category: undefined });
        }
    }

    const handleCountryCodeChange = (value) => {
        setCountryCode(value);
        form.setFieldsValue({ country_code: value });
    };

    const CheckPhoneUser = async () => {
        const values = await form.validateFields(['phone_no']);
        const phoneNumber = values.phone_no;
        await checkPhoneNumber(phoneNumber);
    }

    const UserPaymentHistoryHandel = async () => {
        setpaymentUserData(null);
        const values = await form.validateFields(['phone_no']);
        const phoneNumber = values.phone_no;
        if ((countryCode !== '91' || phoneNumber.length >= 10) && userId) {
            await checkPhoneNumberView(phoneNumber, 'view');
            setUserPaymentHistory(true);
        }
    };

    const handleUserPaymentHistoryClose = () => {
        setUserPaymentHistory(false);
    };

    const handleOk = async () => {
        if (checkedOption === 'usePrimaryNumber') {
            form.setFieldsValue({
                phone_no: alternativeNumber1 ? alternativeNumber1 : alternativeNumber2,
            });
        } else if (checkedOption === 'newMember') {
            setAlternativeNumber1('');
            setAlternativeNumber2('');
            setUserId(null);
            setProfileImg(null);
            clearUserData();
        }
        console.log('Checked option:', checkedOption);
        handleModalForConfirmationClose();
    };

    const monthCellRender = (date) => {
        const isPaid = paidMonths.some(
            (paidMonth) => paidMonth.year() === date.year() && paidMonth.month() === date.month()
        );

        return (
            <div style={{ backgroundColor: isPaid ? '#d4edda' : '', color: isPaid ? 'green' : 'inherit', cursor: isPaid ? 'not-allowed' : 'pointer' }}>
                {date.format('MMM')}
            </div>
        );
    };

    const disabledDate = (current) => {
        return paidMonths.some(
            (paidMonth) => current.year() === paidMonth.year() && current.month() === paidMonth.month()
        );
    };

    const debounceConvertText = useRef(_.debounce(async (text, column) => {
        try {
            const response = await axios.post(`${baseUrl}/translate`, { text });
            form.setFieldsValue({
                [column]: response.data.translatedText,
            });
        } catch (error) {
            console.error('Error translating text:', error);
        }
    }, 300)).current;

    function handleInputChange(text, column) {
        const newText = text;
        debounceConvertText(newText, column);
    };

    const addNewMember = async () => {
        if (userId) {
            handleModalNewMemberClose();
            setuserBasicDetail({})
            setAddEditUserDetailsForm(null)
            setPrimaryId(userId);
            setAlternativeNumber1('');
            setAlternativeNumber2('');
            setpaymentUserData(null);
            setUserId(null);
            setProfileImg(null);
            setIsNewMember(true);

            form.setFieldsValue({
                user_id: '',
                name_eng: '',
                father_name_en: '',
                profile_img: '',
                relation_en: '',
                father_name_hn: '',
                name_hn: '',
                relation_hn: '',
                month_share_amount: '',
                announced_pay_year: '',
                frequency_type: '',
                per_village_en: '',
                per_tahsil_en: '',
                per_district_en: '',
                per_village_hn: '',
                per_tahsil_hn: '',
                per_district_hn: '',
                is_calendar: '',
                no_calendar: '',
                calendar_per_name: '',
                is_honored: ''
            });
        }
    }

    const columnsChildren = [
        {
            title: "Member Name",
            dataIndex: "name_eng",
            key: "name_eng",
            fixed: 'left',
            render: (text, record) => (
                <span>
                    {record.name_hn || text}
                    {!record.parent_id && record.user_id !== userId && (
                        <Tag color="blue" style={{ marginLeft: 6, fontSize: 10 }}>Same No.</Tag>
                    )}
                </span>
            )
        },
        {
            title: "Relation",
            dataIndex: "relation_en",
            key: "relation_en",
            fixed: 'left',
            render: (text, record) => record.relation_hn || text
        },
        {
            title: "Father Name",
            dataIndex: "father_name_en",
            key: "father_name_en",
            fixed: 'left',
            render: (text, record) => record.father_name_hn || text
        },
        {
            title: "Monthly Share",
            dataIndex: "announced_amount",
            key: "announced_amount",
            render: (v) => v ? `Rs.${v}` : '-'
        },
        {
            title: "Action",
            key: "action",
            render: (text, record) => (
                <Button
                    onClick={() => handleChangeData(record, true)}
                    type={record.user_id === userId ? 'primary' : 'default'}
                    icon={record.user_id === userId ? <CheckCircleOutlined /> : null}
                    style={record.user_id === userId ? { backgroundColor: 'green', borderColor: 'green', color: 'white' } : {}}
                >
                    {record.user_id === userId ? 'Selected' : 'Add Payment'}
                </Button>
            ),
        }
    ];

    const fetchChildrenMember = async (userId) => {
        addNewMember();
    };

    const handleChangeData = (record, isChildren) => {
        const { user_id, phone_no, name_eng, father_name_en, relation_en, name_hn, relation_hn, father_name_hn, announced_amount, announced_type, announced_for_year, alternate_phone_no, alternate_phone_no2, status, per_village_en, per_tahsil_en, per_district_en, per_village_hn, per_tahsil_hn, per_district_hn, per_address_en, per_address_hn, profile_img, is_calendar, no_calendar, calendar_per_name, is_honored } = record;

        setChildrenId(isChildren ? user_id : null);
        setUserId(user_id);
        setProfileImg(profile_img);
        setSwitchChecked(status);
        setPrimaryId(isChildren ? null : user_id);
        setIsNewMember(false);
        setIsShopDonation(relation_en === 'Business/Other');
        setuserBasicDetail(record);
        // Fetch badge data for this user
        axios.get(`${baseUrl}/users/read/${user_id}`, { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } })
            .then(res => { if (res.data.result) setUserBadges({ account_count: res.data.result.account_count || 0, years_active: res.data.result.years_active || 0 }); })
            .catch(() => {});
        if (status?.toLowerCase() === 'inactive') {
            setIsInactiveWarningVisible(true);
        }
        setIsCalendar(is_calendar && is_calendar !== 'null' ? is_calendar : '');
        setNoCalendar(no_calendar && no_calendar !== 'null' ? no_calendar : '');
        setCalendarPerName(calendar_per_name && calendar_per_name !== 'null' ? calendar_per_name : '');
        setIsHonored(is_honored && is_honored !== 'null' ? is_honored : '');

        form.setFieldsValue({
            user_id: user_id,
            name_eng: name_eng || '',
            father_name_en: father_name_en || '',
            profile_img: profile_img,
            relation_en: toEnglishRelation(relation_en) || 'Son of Mr.',
            father_name_hn: father_name_hn || '',
            name_hn: name_hn || '',
            relation_hn: relation_hn || 'सुपुत्र श्री',
            month_share_amount: announced_amount,
            frequency_type: announced_type,
            announced_pay_year: announced_for_year,
            per_village_en: per_village_en || '',
            per_tahsil_en: per_tahsil_en || '',
            per_district_en: per_district_en || '',
            per_village_hn: per_village_hn || '',
            per_tahsil_hn: per_tahsil_hn || '',
            per_district_hn: per_district_hn || '',
            per_address_en: per_address_en || '',
            per_address_hn: per_address_hn || '',
            is_calendar: (is_calendar && is_calendar !== 'null') ? is_calendar : '',
            no_calendar: (no_calendar && no_calendar !== 'null') ? no_calendar : '',
            calendar_per_name: (calendar_per_name && calendar_per_name !== 'null') ? calendar_per_name : '',
            is_honored: (is_honored && is_honored !== 'null') ? is_honored : '',
        });
    };

    const relationMapping = {
        "Son of Mr.": "सुपुत्र श्री",
        "Daughter of Mr.": "सुपुत्री श्री",
        "Wife of Mr.": "पत्नी श्री",
        "Adopted Son of Mr.": "गोद पुत्र श्री",
        "Disciple of Mr.": "शिष्य श्री",
        "Business/Other": "व्यवसाय/अन्य"
    };

    const toEnglishRelation = (val) => reverseRelationMapping[val] || val;

    const handleRelationChange = (value) => {
        const hindiValue = relationMapping[value];
        const isShop = value === 'Business/Other';
        setIsShopDonation(isShop);
        form.setFieldsValue({
            relation_en: value,
            relation_hn: hindiValue,
            ...(isShop ? { father_name_en: '', father_name_hn: '' } : {})
        });
    };

    const handlePaymentStatusChange = (value) => {
        setPaymentStatus(value);
    };

    const handleDateChange = (date, dateString) => {
        if (date) {
            const formattedDate = moment(date).format('YYYY-MM-DD');
            setTransactionDate(formattedDate)
            form.setFieldsValue({ tnxDate: date });
        } else {
            setTransactionDate(null);
            form.setFieldsValue({ tnxDate: null });
        }
    };

    const getPanelValue = async (searchText, columnName, tableName) => {
        if (searchText.length < 3) {
            setOptionSuggestion([]);
            return;
        }

        try {
            const response = await axios.get(`${baseUrl}/payments/getSuggestionValue/`, {
                params: { q: searchText, column: columnName, table: tableName },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            });
            if (response.status === 200) {
                setOptionSuggestion(response.data.result);
                if (columnName === 'utr_number' && Array.isArray(response.data.result) && response.data.result.length > 0) {
                    openNotification('top', response.data.result);
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleChangeSuggestion = (value, columnName) => {
        form.setFieldsValue({
            [columnName]: value
        });
    };

    const openNotification = (placement, data) => {
        console.log("data", data);
        notification.destroy();
        notification.open({
            message: 'Alert',
            description: `Transaction details (UTR/ID) already exist (${data[0].name_eng}/${data[0].phone_no})`,
            placement,
        });
    };

    const handleSwitchChange = async (checked) => {
        setSwitchChecked(checked);
        const response = await axios.patch(`${baseUrl}/users/update-announced-year/${userId}`, { status: checked }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
        });
        if (response.status === 200) {
            setChildrenList((prevChildrenList) =>
                prevChildrenList.map((child) =>
                    child.user_id === userId
                        ? { ...child, status: checked }
                        : child
                )
            );
            notification.info({
                message: 'Info',
                description: "Member Status Updated successfully",
                placement: 'topRight'
            });
        } else {
            notification.info({
                message: 'Info',
                description: response.message,
                placement: 'topRight'
            });
        }
        console.log("Switch checked:", checked);
    };

    const countryCodes = [
        "91", "93", "355", "213", "376", "244", "54", "374", "297", "247", "61", "43", "994",
        "973", "880", "375", "32", "501", "229", "1,441", "975", "591", "387", "267",
        "55", "1,284", "673", "359", "226", "95", "257", "855", "237", "1", "238",
        "1,345", "236", "235", "56", "86", "61", "61", "57", "269", "242", "682",
        "506", "385", "53", "357", "420", "243", "45", "246", "253", "1767", "593",
        "20", "503", "240", "291", "372", "251", "500", "298", "679", "358", "33",
        "594", "689", "241", "220", "995", "49", "233", "350", "30", "299", "1,473",
        "590", "1,671", "502", "224", "245", "592", "509", "39", "504", "852", "36",
        "354", "62", "98", "964", "353", "44", "972", "39", "225", "1876",
        "81", "44", "962", "7", "254", "686", "965", "996", "856", "371", "961",
        "266", "231", "218", "423", "370", "352", "853", "389", "261", "265", "60",
        "960", "223", "356", "692", "596", "222", "230", "262", "52", "691", "373",
        "377", "976", "382", "1,664", "212", "258", "264", "674", "977", "31", "599",
        "687", "64", "505", "227", "234", "683", "672", "850", "1670", "47", "968",
        "92", "680", "970", "507", "675", "595", "51", "63", "870", "48", "351",
        "974", "242", "262", "40", "7", "250", "590", "290", "1869", "1,758", "590",
        "508", "1,784", "685", "378", "239", "966", "221", "381", "248", "232", "65",
        "1,721", "421", "386", "677", "252", "27", "82", "211", "34", "94", "249",
        "597", "47", "268", "46", "41", "963", "886", "992", "255", "66", "670",
        "228", "690", "676", "1868", "216", "90", "993", "1,649", "688", "256",
        "380", "971", "44", "1", "598", "1340", "998", "678", "58", "84", "681",
        "212", "967", "260", "263"
    ];

    const handlePaymentModeChange = (value) => {
        const modesToShow = ['Cash', 'Website-Razorpay', 'Application-Razorpay', 'Registration-Rozapay'];
        setShowEReceiptFields(modesToShow.includes(value));
        const gatewayModes = ['Website-Razorpay', 'Application-Razorpay', 'Member-Portal-Rozapay', 'Registration-Rozapay'];
        const isGateway = gatewayModes.some(m => value?.toLowerCase().includes('razorpay') || value?.toLowerCase().includes('rozapay'));
        setShowGatewayFields(isGateway);
        if (!isGateway) {
            form.setFieldsValue({ razorpay_fee: null, razorpay_gst: null, net_amount: null });
        }
    };

    const handleReciptDateChange = (date, dateString) => {
        if (date) {
            const formattedDate = moment(date).format('YYYY-MM-DD');
            setErecipt_date(formattedDate)
        } else {
            setErecipt_date(null);
        }
    };

    const handleSaveComment = async () => {
        if (!phoneNumberUse) {
            notification.info({
                message: 'Info',
                description: 'Please add user phone no.',
                placement: 'topRight'
            });
            return;
        } else if (!userId) {
            notification.info({
                message: 'Info',
                description: 'Please add user then add comment',
                placement: 'topRight'
            });
            return;
        } else if (!userComment) {
            notification.info({
                message: 'Info',
                description: 'Comment is required',
                placement: 'topRight'
            });
            return;
        }
        const response = await axios.patch(`${baseUrl}/users/update-comment/${userId}`, { comment: userComment }, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
        });
        if (response.status === 200) {
            notification.info({
                message: 'Info',
                description: "Comment updated successfully",
                placement: 'topRight'
            });
        } else {
            notification.info({
                message: 'Info',
                description: response.message,
                placement: 'topRight'
            });
        }
    };

    const showModal = (image) => {
        setCurrentImage(image || userDummy);
        setIsModalVisibleImg(true);
    };

    const handleCancel = () => {
        setIsModalVisibleImg(false);
    };

    // Enhanced member status indicator
    // const getMemberStatusColor = () => {
    //     if (isNewMember) return '#52c41a'; // Green for new member
    //     if (userId) return '#1890ff'; // Blue for existing member
    //     return '#d9d9d9'; // Gray for no member
    // };

    // const getMemberStatusText = () => {
    //     if (isNewMember) return 'New Member - Ready to Create';
    //     if (userId) return `Member ID: ${userId}`;
    //     return 'No Member Selected';
    // };

    const getStatusTagColor = () => {
    if (isNewMember) return 'green';
    if (!userId) return 'default';
  
  // Get status from user details or default to 'Active'
  const status = userBasicDetail?.status || 'Active';
  
        switch(status.toLowerCase()) {
            case 'active': return 'green';
            case 'inactive': return 'red';
            case 'pending': return 'orange';
            case 'suspended': return 'volcano';
            default: return 'blue';
        }
        };

        const getMemberStatusText = () => {
        if (isNewMember) return 'New Member';
        if (!userId) return 'No Member';
        
        // Get status from user details or default to 'Active'
        const status = userBasicDetail?.status || 'Active';
        return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
        };

        const getMemberStatusColor = () => {
        if (isNewMember) return '#52c41a'; // Green for new member
        if (userId) return '#1890ff'; // Blue for existing member
        return '#d9d9d9'; // Gray for no member
        };

    return (
        <>
            {loading && (
                <div className="full-page-loader">
                    <Spin size="large" />
                </div>
            )}
            <div className="tabled">
                <Row gutter={[24, 0]}>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title={
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>Add Payment</span>
                                    <Space>
                                        <Button
                                            icon={<ReloadOutlined />}
                                            size="small"
                                            onClick={() => window.location.reload()}
                                        >
                                            Refresh
                                        </Button>
                                        <Button
                                            icon={<ClearOutlined />}
                                            size="small"
                                            onClick={() => {
                                                form.resetFields();
                                                form.setFieldsValue({ bank_account: "1", payment_virify: "pending", pyament_mode_type: "UPI", tnxDate: moment() });
                                                setuserBasicDetail({});
                                                setUserId(null);
                                                setProfileImg(null);
                                                setPaidMonths([]);
                                                setPhoneNumber('');
                                                setLastPayment('');
                                            }}
                                        >
                                            Clear
                                        </Button>
                                    </Space>
                                </div>
                            }
                            headStyle={{ minHeight: 40, padding: '0 16px', lineHeight: '40px' }}
                        >
                            <Form
                                style={{ padding: '8px' }}
                                className="add-payment-form"
                                form={form}
                                onFinish={onFinish}
                                layout="vertical"
                                initialValues={{
                                    bank_account: "1",
                                    payment_virify: "pending",
                                    pyament_mode_type: "UPI",
                                    tnxDate: moment(),
                                    relation_en: 'Son of Mr.',
                                    relation_hn: 'सुपुत्र श्री'
                                }}
                            >
                                
                                <Row gutter={[12, 8]}>
                                    {/* ==================== TOP SECTION: USER DETAILS ==================== */}
                                    <Col xs={24}>
                                        {/* <Card 
                                            title={
                                                <Row justify="space-between" align="middle" style={{ width: '100%' }}>
                                                    <Col>
                                                        <span style={{ fontWeight: 'bold' }}>Member Details</span>
                                                    </Col>
                                            
                                                    <Col>
                                                        <div style={{
                                                            backgroundColor: getMemberStatusColor(),
                                                            padding: '2px 10px',
                                                            borderRadius: '20px',
                                                            color: '#fff',
                                                            fontWeight: 600,
                                                            fontSize: '13px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            minWidth: '120px',
                                                            height: '26px',
                                                            gap: '6px'
                                                        }}>
                                                            {userId && (
                                                            <>
                                                                <span>ID: {userId}</span>
                                                                <Divider type="vertical" style={{ borderColor: '#0b0909ff', height: '16px' }} />
                                                            </>
                                                            )}
                                                            <Tag 
                                                            color={getStatusTagColor()} 
                                                            style={{ 
                                                                margin: 0, 
                                                                color: '#ee6f06ff', 
                                                                border: 'none',
                                                                fontWeight: 600
                                                            }}
                                                            >
                                                            {getMemberStatusText()}
                                                            </Tag>
                                                        </div>
                                                        </Col>
                                                </Row>
                                            }
                                            bordered={false} 
                                            headStyle={{
                                                backgroundColor: '#f0f2f5', 
                                                borderBottom: '1px solid #d9d9d9',
                                                padding: '0 10px'
                                            }}
                                            bodyStyle={{
                                                padding: '10px'
                                            }}
                                        > */}

                                        <div style={{
                                            border: isVisheshSahyogi ? '1px solid #ffe58f' : '1px solid #d9d9d9',
                                            borderRadius: 8,
                                            overflow: 'hidden',
                                        }}>
                                            {/* Section Header */}
                                            <div style={{
                                                backgroundColor: isVisheshSahyogi ? '#fffbe6' : '#f0f2f5',
                                                borderBottom: '1px solid #d9d9d9',
                                                padding: '5px 10px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                gap: 8,
                                            }}>
                                                <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <span style={{ fontWeight: 600, fontSize: 14 }}>Member Details</span>
                                                    {userId && userBadges.account_count >= 2 && (
                                                        <Tooltip title={`Contributing to ${userBadges.account_count} accounts`}>
                                                            <StarFilled style={{ color: '#faad14', fontSize: 13 }} />
                                                        </Tooltip>
                                                    )}
                                                    {userId && (() => {
                                                        const badge = getLoyaltyBadge(userBadges.years_active);
                                                        if (!badge) return null;
                                                        return (
                                                            <Tooltip title={badge.title}>
                                                                <span style={{ fontSize: 10, fontWeight: 700, color: badge.color, background: badge.bg, border: `1px solid ${badge.color}`, borderRadius: 4, padding: '0 4px', lineHeight: '16px' }}>
                                                                    <TrophyFilled style={{ fontSize: 9, marginRight: 2 }} />{badge.label}
                                                                </span>
                                                            </Tooltip>
                                                        );
                                                    })()}
                                                    {/* Mission 21K indicator */}
                                                    {userId && userBasicDetail?.campaign === 'mission_21k' && (
                                                        <Tooltip title={`Mission 21K सदस्य — ₹${userBasicDetail.mission_monthly_amount || 200}/माह`}>
                                                            <span style={{
                                                                fontSize: 10, fontWeight: 800,
                                                                color: '#92400e', background: '#fef3c7',
                                                                border: '1px solid #f59e0b',
                                                                borderRadius: 4, padding: '0 5px',
                                                                lineHeight: '16px', cursor: 'default',
                                                            }}>
                                                                🎯 Mission 21K
                                                            </span>
                                                        </Tooltip>
                                                    )}
                                                </span>
                                                <div style={{
                                                    backgroundColor: getMemberStatusColor(),
                                                    padding: '2px 10px',
                                                    borderRadius: '20px',
                                                    color: '#fff',
                                                    fontWeight: 600,
                                                    fontSize: '13px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px'
                                                }}>
                                                    {userId && (
                                                        <>
                                                            <span>ID: {userId}</span>
                                                            <Divider type="vertical" style={{ borderColor: '#0b0909ff', height: '16px' }} />
                                                        </>
                                                    )}
                                                    <Tag
                                                        color={getStatusTagColor()}
                                                        style={{ margin: 0, color: '#ee6f06ff', border: 'none', fontWeight: 600 }}
                                                    >
                                                        {getMemberStatusText()}
                                                    </Tag>
                                                    {isVisheshSahyogi && (
                                                        <>
                                                            <Divider type="vertical" style={{ borderColor: '#0b0909ff', height: '16px' }} />
                                                            <Tag color="gold" style={{ margin: 0, color: '#000', border: 'none', fontWeight: 600 }}>
                                                                Vishesh Sahyogi
                                                            </Tag>
                                                        </>
                                                    )}
                                                    {userId && userBasicDetail?.payment_commitment === 'one_time' && (
                                                        <>
                                                            <Divider type="vertical" style={{ borderColor: '#0b0909ff', height: '16px' }} />
                                                            <Tooltip title="This member made a one-time contribution. No monthly pending will be calculated.">
                                                                <Tag color="green" style={{ margin: 0, color: '#135200', border: 'none', fontWeight: 700 }}>
                                                                    One-Time Donor
                                                                </Tag>
                                                            </Tooltip>
                                                        </>
                                                    )}
                                                    {userBasicDetail?.category && (
                                                        <>
                                                            <Divider type="vertical" style={{ borderColor: '#0b0909ff', height: '16px' }} />
                                                            <Tag color="blue" style={{ margin: 0, color: '#770505ff', border: 'none', fontWeight: 600 }}>
                                                                {userBasicDetail.category}
                                                            </Tag>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            {/* Section Body */}
                                            <div style={{
                                                padding: '8px',
                                                backgroundColor: isVisheshSahyogi ? '#fffbe6' : 'inherit',
                                            }}>
                                           {isVisheshSahyogi && visheshSahyogiData && (
                                            <div style={{
                                                marginBottom: '16px',
                                                padding: '12px',
                                                backgroundColor: '#fffbe6',
                                                border: '1px solid #ffe58f',
                                                borderRadius: '8px'
                                            }}>
                                                <Row gutter={16}>
                                                <Col span={24}>
                                                    <Title level={5} style={{ color: '#d48806', marginBottom: '8px' }}>
                                                    <TeamOutlined style={{ marginRight: '8px' }} />
                                                    Vishesh Sahyogi Details
                                                    </Title>
                                                </Col>
                                                <Col xs={24} sm={12} md={8}>
                                                    <Typography.Text strong>Pledged Amount: </Typography.Text>
                                                    <Typography.Text>₹{visheshSahyogiData.amount_pledge || '0'}</Typography.Text>
                                                </Col>
                                                <Col xs={24} sm={12} md={8}>
                                                    <Typography.Text strong>Gotra: </Typography.Text>
                                                    <Typography.Text>{visheshSahyogiData.gotra || '-'}</Typography.Text>
                                                </Col>
                                                <Col xs={24} sm={12} md={8}>
                                                    <Typography.Text strong>Committee: </Typography.Text>
                                                    <Typography.Text>{visheshSahyogiData.committee || '-'}</Typography.Text>
                                                </Col>
                                                <Col xs={24} sm={12} md={8}>
                                                    <Typography.Text strong>Village: </Typography.Text>
                                                    <Typography.Text>{visheshSahyogiData.village || '-'}</Typography.Text>
                                                </Col>
                                                <Col xs={24} sm={12} md={8}>
                                                    <Typography.Text strong>Tehsil: </Typography.Text>
                                                    <Typography.Text>{visheshSahyogiData.tehsil || '-'}</Typography.Text>
                                                </Col>
                                                <Col xs={24} sm={12} md={8}>
                                                    <Typography.Text strong>District: </Typography.Text>
                                                    <Typography.Text>{visheshSahyogiData.district || '-'}</Typography.Text>
                                                </Col>
                                                </Row>
                                            </div>
                                            )}

                                            <div style={{ display: 'flex', gap: 12, alignItems: 'stretch' }}>

                                                {/* LEFT FRAME: Phone + Add Family Member + Photo */}
                                                <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', flex: 1, border: '1px solid #e8e8e8', borderRadius: 8, padding: '8px 12px', background: '#fff' }}>
                                                    {/* Phone */}
                                                    <div style={{ flex: 1, minWidth: 0 }}>
                                                        <Item
                                                            className="phone_no custom-form-item"
                                                            label="Phone No."
                                                            name="phone_no"
                                                            validateTrigger={['onChange', 'onBlur']}
                                                            style={{ marginBottom: 0 }}
                                                            rules={[
                                                                { required: true, message: 'Please enter phone no' },
                                                                {
                                                                    validator: (_, value) => {
                                                                        if (!value) return Promise.resolve();
                                                                        if (!/^\d+$/.test(value)) return Promise.reject('Only digits are allowed');
                                                                        if (countryCode === '91' && value.length < 10) return Promise.reject('Phone no must be at least 10 digits');
                                                                        if (value.length > 12) return Promise.reject('Phone no must not exceed 12 digits');
                                                                        return Promise.resolve();
                                                                    }
                                                                },
                                                            ]}
                                                        >
                                                            <Input
                                                                className="PhoneInputs"
                                                                value={phoneNumber}
                                                                onChange={handlePhoneNumberChange}
                                                                maxLength={12}
                                                                placeholder="Phone no."
                                                                addonBefore={
                                                                    <Select
                                                                        defaultValue={countryCode}
                                                                        onChange={handleCountryCodeChange}
                                                                        style={{ width: 80 }}
                                                                    >
                                                                        {countryCodes.map((code) => (
                                                                            <Option key={code} value={code}>
                                                                                +{code}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                }
                                                                prefix={<PhoneOutlined />}
                                                            />
                                                        </Item>
                                                    </div>

                                                    {/* Add Family Member button */}
                                                    {userId && !childrenId && (
                                                        <div style={{ flexShrink: 0, paddingBottom: 1 }}>
                                                            <Button
                                                                type="primary"
                                                                icon={<UserAddOutlined />}
                                                                onClick={() => {
                                                                    Modal.confirm({
                                                                        title: 'Add Family Member',
                                                                        content: 'Are you sure you want to add a new family member under this account? Current member details will be cleared.',
                                                                        okText: 'Yes, Add',
                                                                        cancelText: 'Cancel',
                                                                        okButtonProps: { style: { backgroundColor: '#7a0000', borderColor: '#7a0000' } },
                                                                        onOk: () => fetchChildrenMember(userId),
                                                                    });
                                                                }}
                                                                style={{ backgroundColor: '#7a0000', borderColor: '#7a0000', borderRadius: 8, fontSize: 13, fontWeight: 600, height: 40, whiteSpace: 'nowrap' }}
                                                            >
                                                                Add Family Member
                                                            </Button>
                                                        </div>
                                                    )}

                                                    {/* Photo */}
                                                    {(profileImg || isNewMember) && (
                                                        <div style={{ flexShrink: 0, position: 'relative', paddingBottom: 1 }}>
                                                            <Avatar
                                                                shape="square"
                                                                size={60}
                                                                src={profileImg || userDummy}
                                                                icon={!profileImg && <UserOutlined />}
                                                                onClick={() => showModal(profileImg || userDummy)}
                                                                onMouseEnter={() => setIsHovered(true)}
                                                                onMouseLeave={() => setIsHovered(false)}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    borderRadius: 6,
                                                                    border: isNewMember ? '2px solid #52c41a' : '2px solid #d9d9d9',
                                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                                                    transition: 'transform 0.3s ease',
                                                                    transform: isHovered ? 'scale(1.05)' : 'scale(1)',
                                                                    opacity: isNewMember ? 0.7 : 1,
                                                                }}
                                                            />
                                                            {isNewMember && (
                                                                <div style={{ position: 'absolute', bottom: -8, left: '50%', transform: 'translateX(-50%)', backgroundColor: '#52c41a', color: 'white', padding: '1px 6px', borderRadius: 8, fontSize: 10, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                                                                    NEW
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>

                                                {/* RIGHT FRAME: Comment */}
                                                <div style={{ flexShrink: 0, width: 500, border: '2px solid #d9d9d9', borderRadius: 8, padding: '8px 12px', backgroundColor: '#fafafa' }}>
                                                    <Item
                                                        className="phone_no custom-form-item comment-field"
                                                        label="Comment"
                                                        name="comment"
                                                        style={{ marginBottom: 0 }}
                                                        rules={[{ required: false }]}
                                                    >
                                                        <Input
                                                            type="text"
                                                            onChange={(e) => setUserComment(e.target.value)}
                                                            placeholder="Enter comment"
                                                            disabled={!userId}
                                                            addonAfter={
                                                                <Button
                                                                    style={{ backgroundColor: '#7a0000', borderColor: '#7a0000', color: '#fff', borderRadius: 8 }}
                                                                    className="ant-btn-primary search-add-button"
                                                                    onClick={handleSaveComment}
                                                                    disabled={!userId}
                                                                >
                                                                    Save Comment
                                                                </Button>
                                                            }
                                                        />
                                                    </Item>
                                                    {isModalForConfirmation && (
                                                        <h4 style={{ color: 'red' }}>Primary Number : {alternativeNumber1 || alternativeNumber2}</h4>
                                                    )}
                                                </div>

                                            </div>

                                            {childrenList.length > 0 && (
                                                <Row gutter={[12, 12]} style={{marginTop: 16}}>
                                                    <Col xs={24}>
                                                        <div className="table-responsive">
                                                            <Table
                                                                columns={columnsChildren}
                                                                dataSource={childrenList}
                                                                pagination={false}
                                                                className="ant-border-space addpaymentTable"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}

                                            <Row gutter={[6, 0]} style={{ marginTop: 2 }}>

                                                {/* Name EN + HN */}
                                                <Col xs={12} sm={8} lg={3}>
                                                    <Item className="custom-form-item" label={isShopDonation ? "Business/Other Name" : "Name"} name="name_eng" style={{ marginBottom: 2 }}>
                                                        <Input placeholder={isShopDonation ? "Business/Other Name" : "User Name"} style={{ width: '95%' }} onChange={(e) => handleInputChange(e.target.value, 'name_hn')} />
                                                    </Item>
                                                    <Item className="custom-form-item" label={isShopDonation ? "व्यवसाय/अन्य का नाम" : "नाम"} name="name_hn" style={{ marginBottom: 0 }}>
                                                        <Input placeholder={isShopDonation ? "व्यवसाय/अन्य का नाम" : "नाम दर्ज करें।"} style={{ width: '95%' }} />
                                                    </Item>
                                                </Col>

                                                {/* Relation EN + HN */}
                                                <Col xs={12} sm={8} lg={3}>
                                                    <Item className="custom-form-item" label="Relation" name="relation_en" style={{ marginBottom: 2 }}>
                                                        <Select placeholder="Relation" style={{ width: '90%' }} onChange={handleRelationChange}>
                                                            <Option value="Son of Mr.">Son of Mr.</Option>
                                                            <Option value="Daughter of Mr.">Daughter of Mr.</Option>
                                                            <Option value="Wife of Mr.">Wife of Mr.</Option>
                                                            <Option value="Adopted Son of Mr.">Adopted Son of Mr.</Option>
                                                            <Option value="Disciple of Mr.">Disciple of Mr.</Option>
                                                            <Option value="Business/Other">Business/Other</Option>
                                                        </Select>
                                                    </Item>
                                                    <Item className="custom-form-item" label="संबंध" name="relation_hn" style={{ marginBottom: 0 }}>
                                                        <Select placeholder="संबंध चुनें।" style={{ width: '90%' }}>
                                                            <Option value="सुपुत्र श्री">सुपुत्र श्री</Option>
                                                            <Option value="सुपुत्री श्री">सुपुत्री श्री</Option>
                                                            <Option value="पत्नी श्री">पत्नी श्री</Option>
                                                            <Option value="गोद पुत्र श्री">गोद पुत्र श्री</Option>
                                                            <Option value="शिष्य श्री">शिष्य श्री</Option>
                                                            <Option value="व्यवसाय/अन्य">व्यवसाय/अन्य</Option>
                                                        </Select>
                                                    </Item>
                                                </Col>

                                                {/* Father EN + HN — hidden for Business/Other */}
                                                {!isShopDonation && (
                                                <Col xs={12} sm={8} lg={3}>
                                                    <Item className="custom-form-item" label="Father/Husband Name" name="father_name_en" style={{ marginBottom: 2 }}>
                                                        <Input placeholder="Father/Husband Name" style={{ width: '95%' }} onChange={(e) => handleInputChange(e.target.value, 'father_name_hn')} />
                                                    </Item>
                                                    <Item className="custom-form-item" label="पिता/पति का नाम" name="father_name_hn" style={{ marginBottom: 0 }}>
                                                        <Input placeholder="पिता/पति का नाम दर्ज करें।" style={{ width: '95%' }} />
                                                    </Item>
                                                </Col>
                                                )}
                                                {/* Keep hidden fields so form still submits empty strings for Business/Other */}
                                                {isShopDonation && (
                                                <>
                                                    <Item name="father_name_en" hidden><Input /></Item>
                                                    <Item name="father_name_hn" hidden><Input /></Item>
                                                </>
                                                )}

                                                {/* Village — free type OR pick from master (auto-fills Tehsil + District) */}
                                                <Col xs={12} sm={8} lg={3}>
                                                    <Item className="custom-form-item" label="Village" name="per_village_en" style={{ marginBottom: 2 }}>
                                                        <AutoComplete
                                                            placeholder="Village name..."
                                                            onChange={(val) => val ? searchVillage(val) : setVillageOptions([])}
                                                            onSelect={handleVillageSelect}
                                                            filterOption={false}
                                                            notFoundContent={villageSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type to search or enter manually</span>}
                                                            allowClear
                                                            style={{ width: '90%' }}
                                                            options={villageOptions}
                                                            dropdownStyle={{ minWidth: 300 }}
                                                        />
                                                    </Item>
                                                    <Item className="custom-form-item" label="गाँव" name="per_village_hn" style={{ marginBottom: 0 }}>
                                                        <Input placeholder="गाँव" style={{ width: '90%' }} />
                                                    </Item>
                                                    <Item name="per_village_id" hidden><Input /></Item>
                                                    <Item name="per_address_en" hidden><Input /></Item>
                                                    <Item name="per_address_hn" hidden><Input /></Item>
                                                </Col>

                                                {/* Tehsil EN + HN — auto-filled from village master */}
                                                <Col xs={12} sm={8} lg={3}>
                                                    <Item className="custom-form-item" label="Tehsil" name="per_tahsil_en" style={{ marginBottom: 2 }}>
                                                        <Input placeholder="Tehsil" style={{ width: '90%' }} />
                                                    </Item>
                                                    <Item className="custom-form-item" label="तहसील" name="per_tahsil_hn" style={{ marginBottom: 0 }}>
                                                        <Input placeholder="तहसील" style={{ width: '90%' }} />
                                                    </Item>
                                                </Col>

                                                {/* District EN + HN — auto-filled from village master */}
                                                <Col xs={12} sm={8} lg={3}>
                                                    <Item className="custom-form-item" label="District" name="per_district_en" style={{ marginBottom: 2 }}>
                                                        <Input placeholder="District" style={{ width: '90%' }} />
                                                    </Item>
                                                    <Item className="custom-form-item" label="जिला" name="per_district_hn" style={{ marginBottom: 0 }}>
                                                        <Input placeholder="जिला" style={{ width: '90%' }} />
                                                    </Item>
                                                </Col>

                                                {/* Alert only — sticky in the 6/24 free space right of District */}
                                                <Col xs={24} lg={6} style={{ alignSelf: 'flex-start' }}>
                                                    <div style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                        {optionSuggestion && optionSuggestion.length > 0 && (
                                                            <Card style={{ border: '1px solid #faad14', borderRadius: 8, overflow: 'hidden' }} styles={{ body: { padding: 0 } }}>
                                                                <div style={{ background: '#faad14', padding: '4px 12px' }}>
                                                                    <span style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>ℹ UTR already used — entry still allowed</span>
                                                                </div>
                                                                {/* Row 1: Txn Detail | Name */}
                                                                <div style={{ display: 'flex', borderBottom: '1px solid #ffe8e8', background: '#fff5f5' }}>
                                                                    <div style={{ flex: 1, padding: '4px 10px', borderRight: '1px solid #ffe8e8' }}>
                                                                        <span style={{ fontWeight: 700, color: '#c0392b', fontSize: 11, display: 'block' }}>Txn Detail:</span>
                                                                        <span style={{ color: '#333', fontSize: 13 }}>{optionSuggestion[0].value}</span>
                                                                    </div>
                                                                    <div style={{ flex: 1, padding: '4px 10px' }}>
                                                                        <span style={{ fontWeight: 700, color: '#c0392b', fontSize: 11, display: 'block' }}>Name:</span>
                                                                        <span style={{ color: '#333', fontSize: 13 }}>{optionSuggestion[0].name}</span>
                                                                    </div>
                                                                </div>
                                                                {/* Row 2: Txn Date | Mo. No + Use button inline */}
                                                                <div style={{ display: 'flex', background: '#fff' }}>
                                                                    <div style={{ flex: 1, padding: '4px 10px', borderRight: '1px solid #ffe8e8' }}>
                                                                        <span style={{ fontWeight: 700, color: '#c0392b', fontSize: 11, display: 'block' }}>Txn Date:</span>
                                                                        <span style={{ color: '#333', fontSize: 13 }}>{optionSuggestion[0].transaction_date ? moment(optionSuggestion[0].transaction_date).format('DD MMM YYYY') : '-'}</span>
                                                                    </div>
                                                                    <div style={{ flex: 1, padding: '4px 10px' }}>
                                                                        <span style={{ fontWeight: 700, color: '#c0392b', fontSize: 11, display: 'block' }}>Mo. No:</span>
                                                                        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                                            <span style={{ color: '#333', fontSize: 13 }}>{optionSuggestion[0].phone_no}</span>
                                                                            <Tooltip title="Use this number">
                                                                                <Button type="primary" size="small" icon={<ArrowRightOutlined />}
                                                                                    style={{ background: '#7a0000', borderColor: '#7a0000' }}
                                                                                    onClick={async () => {
                                                                                        const phone = optionSuggestion[0].phone_no;
                                                                                        setPhoneNumber(phone);
                                                                                        form.setFieldsValue({ phone_no: phone });
                                                                                        await checkPhoneNumber(phone);
                                                                                        await checkVisheshSahyogiStatus(phone);
                                                                                    }}
                                                                                />
                                                                            </Tooltip>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        )}
                                                    </div>
                                                </Col>

                                            </Row>

                                            {/* ── Referral Section (new members only) ── */}
                                            {isNewMember && (
                                                <div style={{ background: '#f0f7ff', border: '1px solid #91caff', borderRadius: 8, padding: '8px 12px', marginTop: 8 }}>
                                                    <div style={{ fontSize: 12, fontWeight: 700, color: '#1677ff', marginBottom: 6 }}>संदर्भ / रेफरल जानकारी</div>
                                                    <Row gutter={[12, 0]}>
                                                        <Col xs={24} sm={8}>
                                                            <Item label="कैसे जुड़े?" name="ref_source" style={{ marginBottom: 4 }}>
                                                                <Select
                                                                    placeholder="माध्यम चुनें"
                                                                    allowClear
                                                                    onChange={v => { setRefSource(v); form.setFieldsValue({ ref_member_id: undefined }); }}
                                                                >
                                                                    <Option value="member">सदस्य के माध्यम से</Option>
                                                                    <Option value="walk_in">सीधे कार्यालय आकर</Option>
                                                                    <Option value="website">वेबसाइट द्वारा</Option>
                                                                    <Option value="app">एप्लिकेशन द्वारा</Option>
                                                                    <Option value="phone_call">फोन कॉल द्वारा</Option>
                                                                    <Option value="event">कार्यक्रम में</Option>
                                                                    <Option value="other">अन्य</Option>
                                                                </Select>
                                                            </Item>
                                                        </Col>
                                                        {refSource === 'member' && (
                                                            <Col xs={24} sm={8}>
                                                                <Item label="संदर्भ सदस्य (Referrer)" name="ref_member_id" style={{ marginBottom: 4 }}>
                                                                    <Select
                                                                        showSearch
                                                                        labelInValue
                                                                        placeholder="नाम या मोबाइल टाइप करें"
                                                                        filterOption={false}
                                                                        onSearch={searchRefMember}
                                                                        loading={refMemberSearching}
                                                                        notFoundContent={refMemberSearching ? <Spin size="small" /> : 'कोई सदस्य नहीं मिला'}
                                                                        allowClear
                                                                        options={refMemberOptions}
                                                                    />
                                                                </Item>
                                                            </Col>
                                                        )}
                                                        <Col xs={24} sm={refSource === 'member' ? 8 : 16}>
                                                            <Item label="नोट (वैकल्पिक)" name="ref_note" style={{ marginBottom: 4 }}>
                                                                <Input placeholder="कोई अतिरिक्त जानकारी..." />
                                                            </Item>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )}

                                            <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                                                <Button
                                                    onClick={UserPaymentHistoryHandel}
                                                    disabled={!userId}
                                                    icon={<CalendarOutlined />}
                                                    style={{ backgroundColor: userId ? '#7a0000' : '#d9d9d9', borderColor: userId ? '#7a0000' : '#d9d9d9', color: userId ? '#fff' : '#888', borderRadius: 8 }}
                                                >
                                                    Payment History
                                                </Button>

                                                <Button
                                                    onClick={AddUserDetails}
                                                    icon={isNewMember ? <PlusOutlined /> : <EditOutlined />}
                                                    style={{ backgroundColor: '#7a0000', borderColor: '#7a0000', color: '#fff', borderRadius: 8 }}
                                                >
                                                    {isNewMember ? 'Create Member' : 'My Account'}
                                                </Button>

                                                <Tooltip title="संदर्भ / रेफरल जानकारी">
                                                    <Button
                                                        onClick={openRefDialog}
                                                        icon={<TeamOutlined />}
                                                        style={{ backgroundColor: '#722ed1', borderColor: '#722ed1', color: '#fff', borderRadius: 8 }}
                                                    >
                                                        Referral
                                                    </Button>
                                                </Tooltip>

                                                {/* Payment Type — inline next to Referral, visible when member is loaded */}
                                                {userId && (
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                        <span style={{ fontSize: 13, fontWeight: 600, color: '#7a0000', whiteSpace: 'nowrap' }}>Payment Type :</span>
                                                        <Select
                                                            value={userBasicDetail?.payment_commitment || 'recurring'}
                                                            style={{ width: 145 }}
                                                            onChange={async (val) => {
                                                                try {
                                                                    await axios.patch(
                                                                        `${baseUrl}/users/update-payment-commitment/${userId}`,
                                                                        { payment_commitment: val },
                                                                        { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
                                                                    );
                                                                    setuserBasicDetail(prev => ({ ...prev, payment_commitment: val }));
                                                                    message.success(val === 'one_time' ? 'Set as One-Time donor' : 'Set as Monthly (Recurring)');
                                                                } catch {
                                                                    message.error('Failed to update payment type');
                                                                }
                                                            }}
                                                        >
                                                            <Option value="recurring">Monthly</Option>
                                                            <Option value="one_time">One-Time</Option>
                                                        </Select>
                                                    </div>
                                                )}
                                            </div>
                                            </div>{/* /body */}
                                        </div>{/* /Member Details */}
                                    </Col>

                                    {/* Payment Details */}
                                        <Col xs={24}>
                                        <div style={{ border: '1px solid #d9d9d9', borderRadius: 8, overflow: 'hidden' }}>
                                            {/* Section Header */}
                                            <div style={{
                                                backgroundColor: '#f0f2f5',
                                                borderBottom: '1px solid #d9d9d9',
                                                padding: '5px 16px',
                                                fontWeight: 600,
                                                fontSize: 14,
                                                lineHeight: '28px',
                                            }}>
                                                Payment Details
                                            </div>
                                            {/* Section Body */}
                                            <div style={{ padding: '8px' }}>
                                            <Row gutter={[8, 4]}>
                                                <Col xs={24} sm={24} lg={18}>
                                                    <Row gutter={[12, 4]}>
                                                        <Col xs={24} sm={12} lg={12}>
                                                            <Item className="custom-form-item" label="Account" name="bank_account"
                                                                rules={[{ required: true, message: 'Select Bank Account' }]}
                                                            >
                                                                <Select
                                                                    onChange={handlePaymentTypeChange}
                                                                    className="bank_account"
                                                                    placeholder="Select Account"
                                                                    defaultValue="1"
                                                                    disabled={isBankAccountDisabled}
                                                                >
                                                                    {bankAccountOptions.map(acc => (
                                                                        <Option key={acc.id} value={String(acc.id)}>{acc.account_name}</Option>
                                                                    ))}
                                                                </Select>
                                                            </Item>
                                                        </Col>

                                                        <Col xs={12} sm={8} lg={4} style={{ marginTop: 22 }}>
                                                        <Item
                                                            className="custom-form-item"
                                                            name="is_special_occasion"
                                                            valuePropName="checked"
                                                            style={{ marginBottom: 0 }}
                                                        >
                                                            <Checkbox
                                                            checked={showSpecialOccassionCategory}
                                                            onChange={handleSpecialOccassionCategory}
                                                            className="custom-checkbox occansanscheck"
                                                            >
                                                            <Tooltip
                                                                title="Check this box if this payment is for a special occasion like Birthday, Anniversary, Marriage, etc. or for suspense entries that need special categorization."
                                                                placement="top"
                                                            >
                                                                <span
                                                                style={{
                                                                    cursor: 'help',
                                                                    textDecoration: 'underline',
                                                                    color: '#085eafff',
                                                                    fontSize: '16px',
                                                                    marginLeft: '8px'
                                                                }}
                                                                >
                                                                IsSpecial/Suspense
                                                                </span>
                                                            </Tooltip>
                                                            </Checkbox>
                                                        </Item>
                                                        </Col>

                                                        {showSpecialOccassionCategory && (
                                                            <Col xs={24} sm={24} lg={8}>
                                                                <Item className="custom-form-item" label="Special Occassion/Suspense Entries" name="special_occassion_category"
                                                                    rules={[{ required: true, message: 'Select Special Occassion' }]}>
                                                                    <Select
                                                                        placeholder="Special Occassion"
                                                                        showSearch
                                                                        allowClear
                                                                        filterOption={(input, option) => (option?.children ?? '').toLowerCase().includes(input.toLowerCase())}
                                                                        onChange={(val) => {
                                                                            const isOther = val === 'Any - Other';
                                                                            setIsCustomOccasion(isOther);
                                                                            if (isOther) form.setFieldsValue({ special_occassion_category: '' });
                                                                        }}
                                                                        onClear={() => setIsCustomOccasion(false)}
                                                                    >
                                                                        {specialOccasionOptions.map(opt => (
                                                                            <Option key={opt.id} value={opt.category_name}>{opt.category_name}</Option>
                                                                        ))}
                                                                    </Select>
                                                                </Item>
                                                                {isCustomOccasion && (
                                                                    <Item
                                                                        className="custom-form-item"
                                                                        label="Custom Occasion Name"
                                                                        name="special_occassion_category"
                                                                        rules={[{ required: true, message: 'Please enter the occasion name' }]}
                                                                        style={{ marginTop: 4 }}
                                                                    >
                                                                        <Input placeholder="e.g. Graduation, Puja, Donation..." autoFocus />
                                                                    </Item>
                                                                )}
                                                            </Col>
                                                        )}

                                                        <Divider style={{ margin: '2px 0' }} />

                                                        {/* ── Screenshot Extractor ── */}
                                                        <Col xs={24} style={{ marginBottom: 6 }}>
                                                            <div
                                                                onPaste={handleScreenshotPaste}
                                                                tabIndex={0}
                                                                style={{
                                                                    border: screenshotImg ? '2px solid #52c41a' : '2px dashed #d9d9d9',
                                                                    borderRadius: 6,
                                                                    padding: '6px 10px',
                                                                    background: screenshotImg ? '#f6ffed' : '#fafafa',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: 12,
                                                                    flexWrap: 'wrap',
                                                                    cursor: 'text',
                                                                    outline: 'none',
                                                                }}
                                                            >
                                                                <ScanOutlined style={{ fontSize: 22, color: screenshotImg ? '#52c41a' : '#aaa' }} />
                                                                {screenshotImg ? (
                                                                    <>
                                                                        <img src={screenshotImg} alt="screenshot" style={{ height: 40, borderRadius: 4, border: '1px solid #b7eb8f' }} />
                                                                        <div style={{ flex: 1 }}>
                                                                            {extractResult ? (
                                                                                <div style={{ fontSize: 12, color: '#389e0d' }}>
                                                                                    <CheckOutlined /> &nbsp;
                                                                                    {extractResult.amount    && <span>₹{extractResult.amount} &nbsp;|&nbsp; </span>}
                                                                                    {extractResult.utr_number && <span>UTR: {extractResult.utr_number} &nbsp;|&nbsp; </span>}
                                                                                    {extractResult.transaction_date && <span>Date: {moment(extractResult.transaction_date).format('DD MMM YYYY')}</span>}
                                                                                </div>
                                                                            ) : (
                                                                                <span style={{ fontSize: 12, color: '#555' }}>Screenshot ready — click <b>Extract</b></span>
                                                                            )}
                                                                        </div>
                                                                        <Button
                                                                            size="small"
                                                                            onClick={() => { setScreenshotImg(null); setExtractResult(null); }}
                                                                            style={{ marginLeft: 'auto' }}
                                                                        >Clear</Button>
                                                                    </>
                                                                ) : (
                                                                    <span style={{ color: '#aaa', fontSize: 13 }}>
                                                                        <b>Paste screenshot here</b> (Ctrl+V) &nbsp;or&nbsp;
                                                                        <span
                                                                            style={{ color: '#1890ff', cursor: 'pointer', textDecoration: 'underline' }}
                                                                            onClick={() => screenshotInputRef.current?.click()}
                                                                        >browse file</span>
                                                                    </span>
                                                                )}
                                                                <input
                                                                    ref={screenshotInputRef}
                                                                    type="file"
                                                                    accept="image/*"
                                                                    style={{ display: 'none' }}
                                                                    onChange={e => handleScreenshotFile(e.target.files[0])}
                                                                />
                                                            </div>
                                                            {screenshotImg && !extractResult && (
                                                                <Button
                                                                    type="primary"
                                                                    icon={<CameraOutlined />}
                                                                    loading={extractLoading}
                                                                    onClick={extractFromScreenshot}
                                                                    style={{ marginTop: 8 }}
                                                                    size="small"
                                                                >
                                                                    Extract Amount, UTR & Date
                                                                </Button>
                                                            )}
                                                        </Col>

                                                        {/* <Col xs={24} sm={12} lg={8}>
                                                            <Item className="custom-form-item" label="Amount Rs." name="amount" rules={[{ required: true, message: 'Please enter amount' }]}>
                                                                <InputNumber className="input_number_type" placeholder="Enter Amount Rs." />
                                                            </Item>
                                                        </Col> */}

                                                        <Col xs={24} sm={12} lg={5}>
                                                            <Form.Item
                                                                label="Amount (₹)"
                                                                name="amount"
                                                                rules={[{ required: true, message: 'Please enter the amount' }]}
                                                                className="custom-form-item"
                                                                colon={false}
                                                                style={{ marginBottom: '4px' }}
                                                            >
                                                                <InputNumber
                                                                    className="input_number_type"
                                                                    placeholder="Enter Amount"
                                                                    style={{ width: '100%' }}
                                                                    min={0}
                                                                    step={1}
                                                                    size="large"
                                                                />
                                                            </Form.Item>
                                                        </Col>


                                                        <Col xs={24} sm={12} lg={7}>
                                                            <Item className="custom-form-item"
                                                                label="Tnx Detail (UTR/ID)"
                                                                name="utr_number"
                                                                rules={[
                                                                    {
                                                                        validator: (_, value) => {
                                                                            if (value && value.trim() === '') {
                                                                                return Promise.reject(new Error('Input cannot be empty or contain only spaces'));
                                                                            }
                                                                            return Promise.resolve();
                                                                        }
                                                                    }
                                                                ]}
                                                            >
                                                                <AutoComplete
                                                                    placeholder="Enter UTR/Tnx"
                                                                    options={optionSuggestion}
                                                                    status={optionSuggestion.length > 0 ? "warning" : ""}
                                                                    onChange={(value) => {
                                                                        const sanitizedValue = (value || '').replace(/\s+/g, '');
                                                                        handleChangeSuggestion(sanitizedValue, "utr_number");
                                                                        getPanelValue(sanitizedValue, "utr_number", "sn_payments");
                                                                    }}
                                                                />
                                                            </Item>
                                                        </Col>

                                                        <Col xs={24} sm={12} lg={5}>
                                                            <Item className="custom-form-item" label="Tnx Date" >
                                                                <DatePicker
                                                                    onChange={handleDateChange}
                                                                    value={transactionDate && moment(transactionDate)}
                                                                    className="filter_dob" format="DD-MM-YYYY"
                                                                    placeholder="Tnx Date" prefix={<CalendarOutlined />} />
                                                            </Item>
                                                        </Col>

                                                        <Col xs={24} sm={12} lg={7}>
                                                            <Item className="custom-form-item" label="Mode of Payment" name="pyament_mode_type" >
                                                                <Select onChange={handlePaymentModeChange} placeholder="Mode of Payment" >
                                                                    <Option value="UPI">UPI</Option>
                                                                    <Option value="Cash">Cash</Option>
                                                                    <Option value="Cheque">Cheque</Option>
                                                                    <Option value="RTGS-NEFT">RTGS/NEFT</Option>
                                                                    <Option value="Website-Razorpay">Website-Razorpay</Option>
                                                                    <Option value="Application-Razorpay">Application-Razorpay</Option>
                                                                    <Option value="Member-Portal-Rozapay">Member Portal - Rozapay</Option>
                                                                    <Option value="Registration-Rozapay">Registration - Razorpay</Option>
                                                                </Select>
                                                            </Item>
                                                        </Col>

                                                        {/* Recurring members: show Month Covered + Monthly Share */}
                                                        {showCategoryPay && showMonthCoverd && userBasicDetail?.payment_commitment !== 'one_time' && (
                                                            <>
                                                                <Divider orientation="left" plain style={{ margin: '2px 0' }}><span style={{ fontWeight: 'bold', fontSize: 12 }}>SHIKSHA NIDHI</span></Divider>

                                                                <Col xs={24} sm={24} lg={9}>
                                                                    <Form.Item className="custom-form-item"
                                                                        label="Month Covered"
                                                                        name="month_range"
                                                                        rules={[
                                                                            {
                                                                                required: true,
                                                                                message: 'Select the month range',
                                                                            },
                                                                            ({ getFieldValue }) => ({
                                                                                validator(_, value) {
                                                                                    if (!value || value.length !== 2) {
                                                                                        return Promise.reject(new Error('Please select both start and end months'));
                                                                                    }
                                                                                    const [start, end] = value;
                                                                                    if (start.isBefore(end) || start.isSame(end)) {
                                                                                        return Promise.resolve();
                                                                                    }
                                                                                    return Promise.reject(new Error('End month should be greater than or equal to start month'));
                                                                                },
                                                                            }),
                                                                        ]}
                                                                    >
                                                                        <RangePicker
                                                                            picker="month"
                                                                            format="MM-YYYY"
                                                                            placeholder={['Start Month', 'End Month']}
                                                                            style={{ width: '100%' }}
                                                                            monthCellRender={monthCellRender}
                                                                            disabledDate={disabledDate}
                                                                            size="large"
                                                                        />
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col xs={24} sm={12} lg={6}>
                                                                    <Item className="custom-form-item" label="Monthly Share(Rs.)" name="month_share_amount" rules={[{ required: true, message: 'Please Enter Monthly Share Rs.' }]}>
                                                                        <InputNumber className="input_number_type" placeholder="Monthly Share(Rs.)" size="large" style={{ width: '90%' }}/>
                                                                    </Item>
                                                                </Col>

                                                                <Col xs={24} sm={12} lg={9}>
                                                                    <Item className="custom-form-item" label="Remark" name="remarks">
                                                                        <Input placeholder="Remark" style={{ width: '90%' }} />
                                                                    </Item>
                                                                </Col>
                                                            </>
                                                        )}
                                                        
                                                        <Divider style={{ margin: '2px 0' }} />

                                                        {/* Gateway Deductions — only for Razorpay modes */}
                                                        {showGatewayFields && (
                                                            <>
                                                                <Col xs={24}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '4px 0 10px' }}>
                                                                        <div style={{ flex: 1, height: 1, background: '#ffccc7' }} />
                                                                        <span style={{ fontSize: 11, fontWeight: 700, color: '#f5222d', letterSpacing: 1, whiteSpace: 'nowrap' }}>
                                                                            GATEWAY DEDUCTIONS (Optional)
                                                                        </span>
                                                                        <div style={{ flex: 1, height: 1, background: '#ffccc7' }} />
                                                                    </div>
                                                                </Col>
                                                                <Col xs={24} sm={8}>
                                                                    <Item className="custom-form-item" label="Gateway Fee (₹)" name="razorpay_fee"
                                                                        tooltip="Razorpay commission (e.g. ₹0.22)">
                                                                        <InputNumber
                                                                            placeholder="e.g. 0.22"
                                                                            min={0} step={0.01} precision={2}
                                                                            style={{ width: '100%' }}
                                                                            onChange={(fee) => {
                                                                                const gst = form.getFieldValue('razorpay_gst') || 0;
                                                                                const amt = form.getFieldValue('amount') || 0;
                                                                                form.setFieldsValue({ net_amount: parseFloat((amt - (fee || 0) - gst).toFixed(2)) });
                                                                            }}
                                                                        />
                                                                    </Item>
                                                                </Col>
                                                                <Col xs={24} sm={8}>
                                                                    <Item className="custom-form-item" label="GST on Fee (₹)" name="razorpay_gst"
                                                                        tooltip="GST on gateway commission (e.g. ₹0.04)">
                                                                        <InputNumber
                                                                            placeholder="e.g. 0.04"
                                                                            min={0} step={0.01} precision={2}
                                                                            style={{ width: '100%' }}
                                                                            onChange={(gst) => {
                                                                                const fee = form.getFieldValue('razorpay_fee') || 0;
                                                                                const amt = form.getFieldValue('amount') || 0;
                                                                                form.setFieldsValue({ net_amount: parseFloat((amt - fee - (gst || 0)).toFixed(2)) });
                                                                            }}
                                                                        />
                                                                    </Item>
                                                                </Col>
                                                                <Col xs={24} sm={8}>
                                                                    <Item className="custom-form-item" label="Net Received (₹)" name="net_amount"
                                                                        tooltip="Auto-calculated: Amount − Fee − GST">
                                                                        <InputNumber
                                                                            placeholder="Auto-calculated"
                                                                            min={0} step={0.01} precision={2}
                                                                            style={{ width: '100%', background: '#f6ffed' }}
                                                                        />
                                                                    </Item>
                                                                </Col>
                                                            </>
                                                        )}

                                                        <Divider style={{ margin: '2px 0' }} />

                                                        {(!(showCategoryPay && showMonthCoverd) || userBasicDetail?.payment_commitment === 'one_time') && (
                                                            <Col xs={24} sm={12} lg={8}>
                                                                <Item className="custom-form-item" label="Remark" name="remarks">
                                                                    <Input placeholder="Remark" />
                                                                </Item>
                                                            </Col>
                                                        )}

                                                        {/* <Col xs={24} sm={12} lg={8}>
                                                            <Item className="custom-form-item" label="Payment Status" name="payment_virify" rules={[{ required: true, message: 'Please select verified status' }]} >
                                                                <Select defaultValue="pending" value={paymentStatus} onChange={handlePaymentStatusChange} placeholder="Verified Status">
                                                                    <Option value="pending">Pending</Option>
                                                                    <Option value="verified">Verified</Option>
                                                                    <Option value="failed">Failed</Option>
                                                                </Select>
                                                            </Item>
                                                        </Col> */}

                                                        {showEReceiptFields && (
                                                            <>
                                                                <Divider />

                                                                <Col xs={24} sm={12} lg={48}>
                                                                    <Item className="custom-form-item" label=" C/R-Reciept" name="e_reciept_no">
                                                                        <Input placeholder=" C/R - Reciept" />
                                                                    </Item>
                                                                </Col>

                                                                <Col xs={24} sm={12} lg={8}>
                                                                    <Item className="custom-form-item" label="C/R-Date">
                                                                        <DatePicker onChange={handleReciptDateChange}
                                                                            value={erecipt_date && moment(erecipt_date)}
                                                                            className="filter_dob" format="DD-MM-YYYY"
                                                                            placeholder="C/R-Date"
                                                                            prefix={<CalendarOutlined />} />
                                                                    </Item>
                                                                </Col>
                                                            </>
                                                        )}
                                                    </Row>
                                                </Col>

                                                {/* Last Payment History — right of payment fields */}
                                                <Col xs={24} lg={6}>
                                                    {lastPayment && (
                                                        <div style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                            <Card style={{ border: '1px solid #7a0000', borderRadius: 8, overflow: 'hidden' }} styles={{ body: { padding: 0 } }}>
                                                                <div style={{ background: '#7a0000', padding: '6px 12px' }}>
                                                                    <span style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>Last Payment History</span>
                                                                </div>
                                                                {[
                                                                    [
                                                                        { label: 'Amount', value: `Rs.${lastPayment?.[0]?.last_payment_amount || '-'}` },
                                                                        { label: 'Txn Date', value: lastPayment[0].transaction_date ? moment(lastPayment[0].transaction_date).format('DD MMM YYYY') : '-' },
                                                                    ],
                                                                    [
                                                                        { label: 'MOD', value: lastPayment?.[0]?.pyament_mode_type || '-' },
                                                                        { label: 'Txn Detail', value: lastPayment?.[0]?.utr_number || '-' },
                                                                    ],
                                                                    [
                                                                        { label: 'UM/Y (Advance)', value: lastPayment?.[0]?.end_month ? moment(lastPayment[0].end_month).format('MMMM YYYY') : '-' },
                                                                        { label: 'Remarks', value: lastPayment?.[0]?.remarks || '-' },
                                                                    ],
                                                                ].map((rowPair, i) => (
                                                                    <div key={i} style={{ display: 'flex', borderBottom: '1px solid #e8edf3', background: i % 2 === 0 ? '#f7f9fc' : '#fff' }}>
                                                                        {rowPair.map((field, j) => (
                                                                            <div key={j} style={{ flex: 1, padding: '5px 10px', borderRight: j === 0 ? '1px solid #e8edf3' : 'none' }}>
                                                                                <span style={{ fontWeight: 700, color: '#7a0000', fontSize: 12, display: 'block' }}>{field.label}:</span>
                                                                                <span style={{ color: '#333', fontSize: 12 }}>{field.value}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                ))}
                                                                <div style={{ background: '#7a0000', padding: '6px 10px' }}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(255,255,255,0.15)', paddingBottom: 6, marginBottom: 6 }}>
                                                                        <span style={{ color: '#a8c4e0', fontSize: 10, fontWeight: 700 }}>JOIN DATE</span>
                                                                        <span style={{ color: '#fff', fontSize: 12, fontWeight: 600 }}>{lastPayment[0].joining_date ? moment(lastPayment[0].joining_date).format('DD MMM YYYY') : '-'}</span>
                                                                    </div>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                        <span style={{ color: '#fff', fontSize: 12 }}><span style={{ color: '#a8c4e0', fontWeight: 700 }}>TAR: </span>Rs.{lastPayment?.[0]?.total_amount || '-'}</span>
                                                                        <span style={{ color: '#fff', fontSize: 12 }}><span style={{ color: '#a8c4e0', fontWeight: 700 }}>DUR: </span>{lastPayment?.[0]?.total_duration || '-'}</span>
                                                                    </div>
                                                                </div>
                                                            </Card>
                                                        </div>
                                                    )}
                                                </Col>

                                            </Row>

                                           <div
                                                style={{
                                                    backgroundColor: '#f0f2f5',
                                                    border: '1px solid #d9d9d9',
                                                    padding: '8px 12px',
                                                    borderRadius: '8px',
                                                    marginBottom: '8px',
                                                }}
                                                >
                                                <Row justify="space-between" align="middle" style={{ flexWrap: 'wrap' }}>
                                                    {/* LEFT buttons group */}
                                                    <Col xs={24} md={16}>
                                                    <Row gutter={[8, 8]}>
                                                        <Col xs={24} sm={12} md={12} lg={8}>
                                                        <Form.Item>
                                                            <Button
                                                            type="primary"
                                                            htmlType="submit"
                                                            onClick={() => { actionRef.current = 'save'; setAction('save'); }}
                                                            style={{
                                                                backgroundColor: '#7a0000',
                                                                borderColor: '#7a0000',
                                                                color: '#fff',
                                                                fontSize: 14,
                                                                marginLeft: '36px',
                                                                borderRadius: 8,
                                                            }}
                                                            block
                                                            >
                                                            Save/View Payment
                                                            </Button>
                                                        </Form.Item>
                                                        </Col>

                                                        <Col xs={24} sm={12} md={12} lg={8}>
                                                        <Form.Item>
                                                            <Button
                                                            htmlType="submit"
                                                            onClick={() => { actionRef.current = 'next'; setAction('next'); }}
                                                            style={{
                                                                backgroundColor: '#7a0000',
                                                                borderColor: '#7a0000',
                                                                color: '#fff',
                                                                fontSize: 14,
                                                                marginLeft: '76px',
                                                                borderRadius: 8,
                                                            }}
                                                            block
                                                            >
                                                            Save/Next Payment
                                                            </Button>
                                                        </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    </Col>

                                                    {/* RIGHT button */}
                                                    <Col xs={24} md={8} style={{ textAlign: 'right' }}>
                                                    <Form.Item>
                                                        <Button
                                                        htmlType="submit"
                                                        onClick={() => { actionRef.current = 'not_send'; setAction('not_send'); }}
                                                        style={{
                                                            backgroundColor: '#7a0000',
                                                            borderColor: '#7a0000',
                                                            color: '#fff',
                                                            fontSize: 14,
                                                            borderRadius: 8,
                                                        }}
                                                        >
                                                        Save Without Poster
                                                        </Button>
                                                    </Form.Item>
                                                    </Col>
                                                </Row>
                                                </div>

                                            </div>{/* /body */}
                                        </div>{/* /Payment Details */}
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>

                {/* Enhanced Drawer for Member Details */}
                <Drawer
                    title={
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>My Account</span>
                            {memberDetailsMode === 'edit' && userId && (
                                <span style={{ color: '#64748b', fontSize: 12, fontWeight: 500 }}>
                                    Member ID: {userId}
                                </span>
                            )}
                            {memberDetailsMode === 'create' && (
                                <span style={{ color: '#64748b', fontSize: 12, fontWeight: 500 }}>
                                    New Member: {phoneNumberUse}
                                </span>
                            )}
                        </div>
                    }
                    headerStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
                    closable={false}
                    extra={<CloseOutlined onClick={AddUserDetailsClose} style={{ color: '#1e293b', fontSize: 18, cursor: 'pointer' }} />}
                    width="75%"
                    onClose={AddUserDetailsClose}
                    open={AddUserDetailsFormModel}
                    styles={{
                        body: {
                            padding: '4px 16px 40px',
                        },
                    }}
                    maskClosable={true}
                >
                    <AddUserDetailsModel
                        userData={AddEditUserDetailsForm}
                        userBasicDetail={userBasicDetail}
                        primaryId={primaryId}
                        onIdChange={handleIdChange}
                        mode={memberDetailsMode}
                        isNewMember={isNewMember}
                        onDrawerClose={AddUserDetailsClose}
                    />
                </Drawer>

                {/* Referral Info Dialog */}
                <Modal
                    open={refDialogOpen}
                    onCancel={() => setRefDialogOpen(false)}
                    onOk={saveRefDialog}
                    confirmLoading={refDialogLoading}
                    okText="Save"
                    title={<span style={{ color: '#722ed1', fontWeight: 700 }}>संदर्भ / रेफरल जानकारी</span>}
                    centered
                    width={520}
                    destroyOnClose
                >
                    <Form form={refDialogForm} layout="vertical" size="small">
                        <Form.Item label="कैसे जुड़े?" name="ref_source">
                            <Select
                                placeholder="माध्यम चुनें"
                                allowClear
                                onChange={v => { setRefDialogSource(v); refDialogForm.setFieldsValue({ ref_member_id: undefined }); }}
                            >
                                <Option value="member">सदस्य के माध्यम से</Option>
                                <Option value="walk_in">सीधे कार्यालय आकर</Option>
                                <Option value="website">वेबसाइट द्वारा</Option>
                                <Option value="app">एप्लिकेशन द्वारा</Option>
                                <Option value="phone_call">फोन कॉल द्वारा</Option>
                                <Option value="event">कार्यक्रम में</Option>
                                <Option value="other">अन्य</Option>
                            </Select>
                        </Form.Item>
                        {refDialogSource === 'member' && (
                            <Form.Item label="संदर्भ सदस्य (Referrer)" name="ref_member_id">
                                <Select
                                    showSearch
                                    labelInValue
                                    placeholder="नाम या मोबाइल टाइप करें"
                                    filterOption={false}
                                    onSearch={searchRefDialogMember}
                                    loading={refDialogMemberSearching}
                                    notFoundContent={refDialogMemberSearching ? <Spin size="small" /> : 'कोई सदस्य नहीं मिला'}
                                    allowClear
                                    options={refDialogMemberOptions}
                                />
                            </Form.Item>
                        )}
                        <Form.Item label="नोट (वैकल्पिक)" name="ref_note">
                            <Input placeholder="कोई अतिरिक्त जानकारी..." />
                        </Form.Item>
                    </Form>
                </Modal>

                {/* Rest of your modals remain the same */}
                <Modal
                    open={isInactiveWarningVisible}
                    onCancel={() => setIsInactiveWarningVisible(false)}
                    onOk={() => setIsInactiveWarningVisible(false)}
                    okText="Okay, Continue"
                    cancelButtonProps={{ style: { display: 'none' } }}
                    title={<span style={{ color: '#faad14' }}>⚠️ Member is Inactive</span>}
                    centered
                >
                    <p style={{ fontSize: '15px', marginBottom: 0 }}>
                        This member is currently <strong style={{ color: 'red' }}>Inactive</strong>.
                        Please activate the member before or after adding the payment.
                    </p>
                </Modal>

                <Modal width={1000}
                    title="Payment Information"
                    open={isModalVisible}
                    onOk={handleModalClose}
                    onCancel={handleModalClose}
                    footer={[
                        <Button key="ok" type="primary" onClick={handleModalClose}>
                            OK
                        </Button>,
                    ]}
                >
                    <div className="scrollable-modal-content">
                        {addedUserData && <UserModalContent userData={addedUserData} />}
                    </div>
                </Modal>

                <Drawer
                    placement="right"
                    width="80%"
                    onClose={handleUserPaymentHistoryClose}
                    open={UserPaymentHistory}
                    closeIcon={<CloseOutlined style={{ fontSize: '18px', color: '#1e293b' }} />}
                    maskClosable={true}
                    headerStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0', padding: '12px 20px'}}
                    title={
                        <Row justify="space-between" align="middle">
                            <Col>
                                <span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>Member Payment Details</span>
                            </Col>
                            <Col>
                                {userId && (
                                    <>
                                        <span style={{ marginRight: 10, color: '#64748b', fontSize: 13 }}>Member Status</span>
                                        <Switch checked={switchChecked} onChange={handleSwitchChange} />
                                    </>
                                )}
                            </Col>
                        </Row>
                    }
                    bodyStyle={{
                        padding: '8px 20px',
                        height: '100%',
                        overflowY: 'auto',
                    }}
                >
                    {paymentUserData ? (
                        <UserPaymentModalHistory userid={paymentUserData} />
                    ) : (
                        <div style={{ textAlign: 'center', padding: '20px 0' }}>No Record Data</div>
                    )}
                </Drawer>

                <Modal
                    title="New Member"
                    open={isModalAddMember}
                    onOk={handleModalNewMemberClose}
                    onCancel={handleModalNewMemberClose}
                    footer={[
                        <Button key="ok" type="primary" onClick={handleModalNewMemberClose}>
                            OK
                        </Button>
                    ]}
                    maskClosable={false}
                >
                    <Row>
                        <Col span={24}>
                            {userId && (
                                <Button style={{ "float": "right" }} className="ant-btn-primary search-add-button" onClick={addNewMember}>New Member</Button>
                            )}
                        </Col>
                    </Row>

                    <div className="table-responsive">
                        <Table
                            columns={columnsChildren}
                            dataSource={childrenList.map((user, index) => ({
                                key: index,
                                id: user.id,
                                name_eng: `${user.name_eng} ${user.name_hn}`
                            }))}
                            pagination={false}
                            className="ant-border-space"
                        />
                    </div>
                </Modal>

                <Modal
                    open={isModalVisibleImg}
                    footer={null}
                    onCancel={handleCancel}
                >
                    <img
                        src={currentImage}
                        alt="Profile"
                        style={{ width: '100%' }}
                    />
                </Modal>

            </div>
        </>
    );
}

export default PaymentsForm;
                                    